import { CurrencyPipe,DatePipe,DecimalPipe,formatDate } from '@angular/common';
import { ChangeDetectorRef,Component,ElementRef,HostListener,OnDestroy,OnInit,TemplateRef,ViewChild } from '@angular/core';
import { FormBuilder,FormControl,Validators } from '@angular/forms';
import { MatLegacyDialog as MatDialog,MatLegacyDialogRef as MatDialogRef } from '@angular/material/legacy-dialog';
import { MatLegacyTableDataSource as MatTableDataSource } from '@angular/material/legacy-table';
import { MatLegacyTabGroup as MatTabGroup } from '@angular/material/legacy-tabs';
import { ActivatedRoute,Router } from '@angular/router';
import { CustomisationFunctionParameterType,EntityType } from '@dave/types';
import { IconProp } from '@fortawesome/fontawesome-svg-core';
import { Actions,ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import moment,{ Moment } from 'moment';
import {
    BehaviorSubject,
    combineLatest,
    combineLatestWith,
    firstValueFrom,
    merge,
    Observable,
    of,
    Subject,
    Subscription,
    from,
} from 'rxjs';
import { distinctUntilChanged,filter,first,map,shareReplay,startWith,switchMap,take,takeUntil,tap,withLatestFrom } from 'rxjs/operators';
import { ShiftplanViews } from 'src/app/dave-calendar/components/scheduler.helper';
import { ITaskBoardSort,TaskBoardFilter } from 'src/app/dave-tasks/components/tasks-board/tasks-board.component';
import { TimelineViewComponent } from '../../../components/history/timeline/timeline-view/timeline-view.component';
import { DaveFileUploadDialogComponent,DaveFileUploadDialogComponentDialogData } from '../../../components/templates/new-document-view/component/dave-file-upload-dialog/dave-file-upload-dialog.component';
import { ResourcePlanComponentDialogData,ResourcePlanDialogComponent } from '../../../dave-calendar/components/resource-plan/resource-plan-dialog/resource-plan-dialog.component';
import { ResourcePlanComponent } from '../../../dave-calendar/components/resource-plan/resource-plan.component';
import { ShiftPlanComponentDialogData,ShiftPlanDialogComponent } from '../../../dave-calendar/components/shift-plan/shift-plan-dialog/shift-plan-dialog.component';
import { ShiftPlanComponent } from '../../../dave-calendar/components/shift-plan/shift-plan.component';
import { AccountsReceivableLedgerEntity,NettoCost } from '../../../dave-data-module/entities/accounts-receivable-ledger.entity';
import { BookmarkEntity } from '../../../dave-data-module/entities/bookmark.entity';
import { CommentEntityTypeEnum } from '../../../dave-data-module/entities/comment.entity';
import {
    CommissionEntity, KostenstellenartEnum,
    KostenstellenartNames,
    SharepointRootFolder,
    SharepointRootFolderType,
} from '../../../dave-data-module/entities/commission.entity';
import {
CommissionTypeNameEnum,
CommissionWizardSteps
} from '../../../dave-data-module/entities/commissionType.entity';
import { DamageFlowEntity } from '../../../dave-data-module/entities/damageflow.entity';
import {
EntityRoleEntity,
EntityRolePermissionNameEnum,
EntityTypesEnum
} from '../../../dave-data-module/entities/entity-role.entity';
import { EventTypeNamesEnum } from '../../../dave-data-module/entities/event-type.entity';
import { EventEntity,ITaskPriority } from '../../../dave-data-module/entities/event.entity';
import { FileEntity } from '../../../dave-data-module/entities/file.entity';
import { FolderEntity,FolderTypes,getFolderTypeString } from '../../../dave-data-module/entities/folder.entity';
import { GeneratedDocumentsEntity } from '../../../dave-data-module/entities/generatedDocuments.entity';
import { GeneratedDocumentsTypeSlugs } from '../../../dave-data-module/entities/generatedDocumentsType.entity';
import { GroupEntity } from '../../../dave-data-module/entities/group.entity';
import { LedgerImportDocumentTypeNames,LedgerImportDocumentTypeNumberLabel,LedgerImportDocumentTypes,LedgerImportEntity } from '../../../dave-data-module/entities/ledger-import.entity';
import { PartnerSpecificationType,PartnerTypeEnum } from '../../../dave-data-module/entities/partner.entity';
import { PersonEntity } from '../../../dave-data-module/entities/person.entity';
import { Person2EntityEntityTypeEnum } from '../../../dave-data-module/entities/person2entity.entity';
import { SharedCommissionsEntity } from '../../../dave-data-module/entities/sharedCommissions.entity';
import {
commissionViewStyleTypes,
ViewStyleConfig,
ViewStyleSettingViewEnum
} from '../../../dave-data-module/entities/viewStyleSetting.entity';
import { ComponentCanDeactivate } from '../../../dave-data-module/guards/pending-changes.guard';
import { PersonResolver } from '../../../dave-data-module/guards/person.resolver';
import { FrontendDate } from '../../../dave-data-module/helper/backend-frontend-conversion.helper';
import { State } from '../../../dave-data-module/State';
import { BookmarkActionTypes } from '../../../dave-data-module/State/actions/bookmarks.actions';
import { CommissionActionTypes } from '../../../dave-data-module/State/actions/commission.actions';
import { FilesActionTypes,FileUploadParams,fileUploadParamsObj } from '../../../dave-data-module/State/actions/files.actions';
import { Person2EntityActionTypes } from '../../../dave-data-module/State/actions/person2entity.action';
import { getQuantityTypes } from '../../../dave-data-module/State/selectors/accounting.selector';
import { getBookmarks } from '../../../dave-data-module/State/selectors/bookmarks.selectors';
import { getCommissionById,getCommissions,getCommissionSorted } from '../../../dave-data-module/State/selectors/commission.selector';
import { getCommissionTypeById,getCommissionTypeDictionary,getCommissionTypes } from '../../../dave-data-module/State/selectors/commissionType.selectors';
import { getComplaintTypes } from '../../../dave-data-module/State/selectors/complaintType.selectors';
import { getCustomerSpecificationTypes } from '../../../dave-data-module/State/selectors/customerSpecificationType.selectors';
import { getDamageFlows } from '../../../dave-data-module/State/selectors/damageflow.selector';
import { getDamageFlowTypes } from '../../../dave-data-module/State/selectors/damageFlowType.selectors';
import { getEmployeeDictionary,getEmployees } from '../../../dave-data-module/State/selectors/employees.selectors';
import { getEntityRole,getEntityRoleFetched } from '../../../dave-data-module/State/selectors/entity-role.selector';
import { getEventTypeFetched,getEventTypes } from '../../../dave-data-module/State/selectors/event-type.selector';
import { getTasks } from '../../../dave-data-module/State/selectors/events.selectors';
import { getGeneratedDocumentsSortedByCreatedAt } from '../../../dave-data-module/State/selectors/generatedDocuments.selectors';
import { getGeneratedDocumentsTypes } from '../../../dave-data-module/State/selectors/generatedDocumentsType.selectors';
import { getLedgerImportByCommissionId,getLedgerImportDictionary,getLedgerImports } from '../../../dave-data-module/State/selectors/ledger-import.selector';
import { getOffices } from '../../../dave-data-module/State/selectors/offices.selectors';
import {
getOwnPartnerOffices,
getPartner,
getPartnerFetched,getPartnerOfficeById,getPartnerOffices,
getPartners
} from '../../../dave-data-module/State/selectors/partners.selectors';
import { getPersonDictionary,getPersons,getPersonsFetched } from '../../../dave-data-module/State/selectors/person.selectors';
import {
getPerson2Entities,
getPerson2EntitiesFetched,getPerson2EntityByCommissionId
} from '../../../dave-data-module/State/selectors/person2entity.selectors';
import { getQMStatus } from '../../../dave-data-module/State/selectors/qMStatus.selectors';
import { getSharedCommissions } from '../../../dave-data-module/State/selectors/sharedCommissions.selectors';
import { getStatusFromSV } from '../../../dave-data-module/State/selectors/status-from-sv.selectors';
import { getStatusFromBackoffice,getStatusFromBackofficeDictionary,getStatusFromBackofficeFetched } from '../../../dave-data-module/State/selectors/statusFromBackoffice.selectors';
import { getUserToCommissionFetched,getUserToCommissions } from '../../../dave-data-module/State/selectors/user-to-commission.selector';
import { getSetting,getSettingFetched,getUser,getUserDictionary } from '../../../dave-data-module/State/selectors/users.selectors';
import { EmailEditorComponent,EmailEditorComponentDialogConfig,EmailEditorComponentDialogData } from '../../../dave-email-module/components/email-editor/email-editor.component';
import { DaveListCardcolumnProperties } from '../../../dave-list-card/dave-list-card.component';
import { SelectPersonsComponent,SelectPersonsComponentDialogData } from '../../../dave-person-module/components/select-persons/select-persons.component';
import { ModifyBookingOptionDialogComponent,ModifyBookingOptionDialogComponentData } from '../../../dave-reports/components/modify-booking-option/modify-booking-option-dialog/modify-booking-option-dialog.component';
import { NewBookingOptionComponent,NewOptionDialogData } from '../../../dave-reports/components/new-booking-option/new-booking-option.component';
import { SelectCommissionDialogComponent,SelectCommissionDialogComponentDialogData } from '../../../dave-select-user/components/select-user-dialogs/select-commission-dialog/select-commission-dialog.component';
import { HourList2Component,HourListComponentDialogData } from '../../../dave-time-tracker/components/hour-list-2/hour-list-2.component';
import { AppDialogService } from '../../../dave-utils-module/app-dialog-module/app-dialog.service';
import { IDetailListTemplateData,IDetailListTemplateDataProperty } from '../../../dave-utils-module/dave-shared-components-module/components/detail-views/detail-list-template/detail-list-template.component';
import { CustomPropertyType } from '../../../dave-utils-module/dave-shared-components-module/components/detail-views/profile-template/profile-template.component';
import { MapDialogComponent } from '../../../dave-utils-module/dave-shared-components-module/components/dialogs/map-dialog/map-dialog.component';
import { PermissionService } from '../../../dave-utils-module/dave-shared-components-module/services/permission.service';
import { RoutingHistoryService } from '../../../dave-utils-module/dave-shared-components-module/services/routing-history.service';
import { SelectSearchData } from '../../../dave-utils-module/select-search/components/select-search-legacy/select-search-legacy.component';
import {
Address,
DaveHeaderHeight,
getAddressString,
getCommissionColorValue,isNotNullOrUndefined,
removeFromViewStyle,
selectViewStyleSetting
} from '../../../helper/helper';
import {
AllEventsMeta,
AllGeneratedDocumentsMeta,
AllReportsMeta,
BookingPositionMetaIcon,
CommissionMeta,
ConstructionDiaryIcon,
ContactBookMeta,
CustomerAdministrationMeta,
DMSPageMeta,
DocumentEditorMeta,
DocumentEditorPageMeta,
GeneratedDocumentsPageMeta,
HistoryMeta,
InvoiceEditorMeta,
PersonMeta,
PieceworkCalculationPageMeta,
ProcessMeta,
ReportsPageMeta,SettingsPageMeta,
SharepointSettingsMeta,
StatisticsPageMeta
} from '../../../helper/page-metadata';
import { CustomLabelService } from '../../../services/custom-label/custom-label.service';
import { FilterTypes } from '../../../services/default-filter.service';
import { LoadingService } from '../../../services/loading.service';
import { NewCallComponent,NewCallComponentDialogData } from '../new-call/new-call.component';
import { NewEventAndTransmissionComponent,NewEventAndTransmissionComponentDialogData } from '../new-event-and-transmission/new-event-and-transmission.component';
import { NewOnSiteEventComponent,NewOnSiteEventComponentDialogData } from '../new-on-site-event/new-on-site-event.component';
import { getViewStyleSetting } from './../../../dave-data-module/State/selectors/viewStyleSetting.selector';
import {
createCommissionFormGroup,
getCommissionFormAddressSearchSubscriptions,
getCommissionFormSubscriptions,
getCommissionLocationOptions,
ICommissionDetailListTemplateEntrys,
resetCommissionFormGroup,
saveCommission,
setCommissionDetailListTemplateEntries
} from './helper';
import { SelectPartnerComponent } from './select-partner/select-partner.component';

import { Inject,LOCALE_ID } from '@angular/core';
import { Permissions } from '@dave/types/dist/proto/global/permissions';
import { Dictionary } from '@ngrx/entity';
import { ToastrService } from 'ngx-toastr';
import { UserRoles } from 'src/app/dave-data-module/entities/user.entity';
import {
    CustomFunctionsSlug,
    CUSTOMIZATION_FUNCTIONS_COMMISSION_SHAREPOINT,
    CustomizationDataService,
} from 'src/app/dave-data-module/services/customization-data.service';
import { getMySharepointToken } from 'src/app/dave-file-explorer/components/file-explorer/sharepoint/sharepoint-helper';
import { DepartmentEntity } from '../../../dave-data-module/entities/department.entity';
import { ProductNames } from '../../../dave-data-module/entities/license.entity';
import { ProcessState,ProcessStateNames,processStateValues } from '../../../dave-data-module/entities/process.entity';
import {
    StatusFromBackofficeEntity,
    StatusFromBackofficeNames,
} from '../../../dave-data-module/entities/statusFromBackoffice.entity';
import { AccountsReceivableLedgerCommissionResolver } from '../../../dave-data-module/guards/accounts-receivable-ledger-comission.resolver';
import { ProcessResolver } from '../../../dave-data-module/guards/process.resolver';
import { getFetched$ } from '../../../dave-data-module/helper/helper';
import { ArlDataService } from '../../../dave-data-module/services/arl-data.service';
import { FolderDataService } from '../../../dave-data-module/services/folder-data.service';
import { LedgerImportActionTypes } from '../../../dave-data-module/State/actions/accounting.actions';
import { BaseActionTypes } from '../../../dave-data-module/State/actions/base.actions';
import { EmployeeResourceScheduleActionTypes } from '../../../dave-data-module/State/actions/resource-dispo/employee-resource-schedule.actions';
import { ChangeSettings } from '../../../dave-data-module/State/actions/settings.actions';
import {
getDepartmentById,
getDepartmentDictionary,getDepartments
} from '../../../dave-data-module/State/selectors/department.selector';
import { getJobSpecification } from '../../../dave-data-module/State/selectors/job-specification.selector';
import { getProcesses,getProcessFetched } from '../../../dave-data-module/State/selectors/process.selector';
import { getUserProducts } from '../../../dave-data-module/State/selectors/products.selectors';
import { getTravelZoneDictionary,getTravelZonesFetched } from '../../../dave-data-module/State/selectors/travel-zone.selector';
import { DetailTasksComponent,DetailTasksComponentDialogData } from '../../../dave-event-card/components/detail-tasks/detail-tasks.component';
import { NewClosingInvoiceComponent,NewClosingInvoiceComponentDialogData,NewClosingInvoiceComponentDialogReturnData } from '../../../dave-reports/components/new-closing-invoice/new-closing-invoice.component';
import { NewPartialInvoiceComponent,NewPartialInvoiceComponentDialogData,NewPartialInvoiceComponentDialogReturnData } from '../../../dave-reports/components/new-partial-invoice/new-partial-invoice.component';
import { NewReportDialogService } from '../../../dave-reports/components/new-report-dialog/new-report-dialog.service';
import { SelectArlDialogService } from '../../../dave-reports/components/select-arl-dialog/select-arl-dialog.service';
import { TaskFilterService } from '../../../dave-tasks/services/task-filter.service';
import { FilterOption,FILTER_TYPE_SEARCH_MULTI_SELECT,IFilterTypeSearchMultiSelectValue } from '../../../dave-utils-module/app-filter-module/app-filter/app-filter.component';
import { BreakpointObserverService } from '../../../dave-utils-module/dave-shared-components-module/services/breakpoint-observer.service';
import { CreateArlFromCommissionService } from '../../../dave-utils-module/dave-shared-components-module/services/create-arl-from-commission-service';
import {
SelectSearchOption
} from '../../../dave-utils-module/select-search/components/select-search/select-search.component';
import { DepartmentService } from '../../../department/department.service';
import { DetailListDialogReturn,DetailListTemplateDialogComponent,DetailListTemplateDialogData } from '../../../detail-list-template-dialog/components/detail-list-template-dialog.component';
import { clacEventFilterAmount,getEventFilterValues,IEventFilterType } from '../../../helper/event.helper';
import { PseudoStepperComponent } from '../../../pseudo-stepper/components/pseudo-stepper/pseudo-stepper.component';
import { DiaryDataService } from '../../../services/diary-data.service';

import { CommissionResolver } from '../../../dave-data-module/guards/commission.resolver';
import { Person2EntityByEntityIdCommissionResolver } from '../../../dave-data-module/guards/person2Entity.resolver';
import { CommissionService } from '../../commission.service';
import { InterruptionEventService } from './interruption-events-list-card/interruption-event.service';
import {
    KaplStatus4DialogComponent,
    MissingCommissionValuesDialogData, MissingCommissionValuesResult,
} from '../kapl-status4-dialog/kapl-status4-dialog.component';
import { UserToCommissionActionTypes } from '../../../dave-data-module/State/actions/user-to-commission.action';

import { CustomerDataService, CustomerSearchState } from '../../../dave-data-module/services/customer-data.service';
import { sharepointFolderNameValidator } from '../../../helper/validation.helper';
import {LedgerImportDataService} from "../../../dave-data-module/services/ledger-import-data.service";

export interface IProcessFilterType {
    [FilterTypes.Status]: IFilterTypeSearchMultiSelectValue[];
}

interface ProcessTemplateTableData {
    ActiveStep: number;
    Name: string;
    Editor: string;
    EndDate: string;
}

function sortViewStyleConfig(conf: ViewStyleConfig[]): ViewStyleConfig[] {
    return conf
        .slice()
        .sort((a, b) => a.order - b.order)
        .map((c) => {
            if (c.elements) {
                return { ...c, elements: sortViewStyleConfig(c.elements) };
            }
            return c;
        });
}


export function getCommissionEmailHtml(commission: CommissionEntity, commissionLabels: { Nominativ: { singular: { value: string } }; wordBinding: string }, versicherungsnehmer?: PersonEntity) {
    const tabledata: { key: string; value: string }[] = [];
    tabledata.push({ key: commissionLabels.wordBinding + 'Nr', value: commission.Auftragsnummer });
    tabledata.push({ key: 'InterneNr', value: commission.InterneNummer });
    tabledata.push({ key: 'SchadenNr', value: commission.Schadennummer });
    let versicherungsNehmerHtml = '';
    if (versicherungsnehmer) {
        versicherungsNehmerHtml += '<h3>Versicherungsnehmer</h3><p>';
        versicherungsNehmerHtml += versicherungsnehmer.Firstname || versicherungsnehmer.Lastname ? `${(versicherungsnehmer.Firstname || '') + ' ' + (versicherungsnehmer.Lastname || '')}</br>` : '';
        versicherungsNehmerHtml += versicherungsnehmer.Street ? `${versicherungsnehmer.Street}</br>` : '';
        versicherungsNehmerHtml += versicherungsnehmer.PostalCode || versicherungsnehmer.City ? `${(versicherungsnehmer.PostalCode || '') + ' ' + (versicherungsnehmer.City || '')}</br>` : '';
        versicherungsNehmerHtml += versicherungsnehmer.PhoneNumber ? `Tel: ${versicherungsnehmer.PhoneNumber}</br>` : '';
        versicherungsNehmerHtml += versicherungsnehmer.Email ? `E-Mail: ${versicherungsnehmer.Email}</br>` : '';
        versicherungsNehmerHtml += '</p>';
    }
    return `<h3>${commissionLabels.Nominativ.singular.value}</h3><p>${tabledata
        .filter((t) => t.value)
        .map((t) => `${t.key}: ${t.value}</br>`)
        .join('')}</p>
${versicherungsNehmerHtml}
`;
}

@Component({
    selector: 'app-detail-commission',
    templateUrl: './detail-commission.component.html',
    styleUrls: ['./detail-commission.component.scss'],
    providers: [CurrencyPipe, DecimalPipe, DatePipe],
})
export class DetailCommissionComponent implements OnInit, OnDestroy, ComponentCanDeactivate {
    @ViewChild('commissionOverviewTemplate') private commissionOverviewTemplate;
    @ViewChild('detailListTemplateCommission') private detailListTemplateCommissionTemplate;
    @ViewChild('group') private groupTemplate;
    @ViewChild('shiftPlanTemplate') private shiftPlanTemplate;
    @ViewChild('resourcePlanTemplate') private resourcePlanTemplate;
    @ViewChild('taskTemplate') private taskTemplate;
    @ViewChild('fileExplorerTemplate') private fileExplorerTemplate;
    @ViewChild('additionalFoldersFileExplorerTemplate') private additionalFoldersFileExplorerTemplate;
    @ViewChild('eventListTemplate') private eventListTemplate;
    @ViewChild('personListTemplate') private personListTemplate;
    @ViewChild('bookingPositionListTemplate') private bookingPositionListTemplate;
    // @ViewChild('invoiceListTemplate') private invoiceListTemplate;
    // @ViewChild('offerListTemplate') private offerListTemplate;
    @ViewChild('ledgerImportListTemplate') private ledgerImportListTemplate;
    @ViewChild('hiddenBookingPositionListTemplate') private hiddenBookingPositionListTemplate;
    @ViewChild('judgeListTemplate') private judgeListTemplate;
    @ViewChild('reportsListDiary') private reportsListDiary;
    @ViewChild('reportsListZusatz') private reportsListZusatz;
    @ViewChild('reportsListBedenken') private reportsListBedenken;
    @ViewChild('reportsListMangel') private reportsListMangel;
    @ViewChild('reportsListErschwernis') private reportsListErschwernis;
    @ViewChild('reportsListOther') private reportsListOther;
    @ViewChild('klaegerListTemplate') private klaegerListTemplate;
    @ViewChild('beklagteListTemplate') private beklagteListTemplate;
    @ViewChild('selectedPartnerListTemplate') private selectedPartnerListTemplate;
    @ViewChild('selectedUsersListTemplate') private selectedUsersListTemplate;
    @ViewChild('tabGroupTemplate') private tabGroupTemplate;
    @ViewChild('nachnahmenListTemplate') private nachnahmenListTemplate;
    @ViewChild('auffaelligkeitListTemplate') private auffaelligkeitListTemplate;
    @ViewChild('reportsListAuffaelligkeit') private reportsListAuffaelligkeit;
    @ViewChild('dokumentationListTemplate') private dokumentationListTemplate;
    @ViewChild('regiearbeitenListTemplate') private regiearbeitenListTemplate;
    @ViewChild('reportsListDokumentation') private reportsListDokumentation;
    @ViewChild('reportsListRegiearbeiten') private reportsListRegiearbeiten;
    @ViewChild('erschwernisListTemplate') private erschwernisListTemplate;
    @ViewChild('mangelanzeigeListTemplate') private mangelanzeigeListTemplate;
    @ViewChild('bedenkenanzeigeListTemplate') private bedenkenanzeigeListTemplate;
    @ViewChild('commentsTemplate') private commentsTemplate;
    @ViewChild('commissionTitleTabGroupTemplate') private commissionTitleTabGroupTemplate;
    @ViewChild('commissionTitleTabGroupTemplateTabGroup') private commissionTitleTabGroupTemplateTabGroup: MatTabGroup;
    @ViewChild('entityHistoryTemplate') private entityHistoryTemplate;
    @ViewChild('resourceListTemplate') private resourceListTemplate;
    @ViewChild('resourceScheduleListeTemplate') private resourceScheduleListeTemplate;
    @ViewChild('materialListTemplate') private materialListTemplate;
    @ViewChild('groupListTemplate') private groupListTemplate;
    @ViewChild('childCommissionsTemplate') private childCommissionsTemplate;
    @ViewChild('reportsTabGroupTemplate') private reportsTabGroupTemplate;
    @ViewChild('processListTemplate') private processListTemplate;
    @ViewChild('CommissionBusinessVolumeList') private CommissionBusinessVolumeList;
    @ViewChild('blueprintTemplate') private blueprintTemplate;
    @ViewChild('departmentSelectTemplate') departmentSelectTemplate: TemplateRef<any>;
    @ViewChild('shiftPlanComponent') private shiftplan: ShiftPlanComponent;
    @ViewChild('resourcePlanComponent') private resourceplan: ResourcePlanComponent;
    @ViewChild('input') private inputRef?: ElementRef<HTMLInputElement>;
    public EntityType = EntityType;
    public CommentEntityTypeEnum = CommentEntityTypeEnum;
    public HeaderHeight = DaveHeaderHeight;
    public PersonMeta = PersonMeta;
    public EreignissCount: number = 0;
    public ConstructionDiaryIcon = ConstructionDiaryIcon;
    public LedgerImportDocumentTypes = LedgerImportDocumentTypes;
    public BookmarkList: BookmarkEntity[] = null;
    public PersonList: PersonEntity[] = null;
    public ShownButtons = true;
    public ShowCommissionButtons = true;
    public showCustomerButtons = true;
    public ShiftPlanActiveView$ = new BehaviorSubject<ShiftplanViews>('Timeline3Month');
    public ResourcePlanActiveView$ = new BehaviorSubject<ShiftplanViews>('Timeline3Month');
    public OpenShiftPlan$ = new Subject<void>();
    public OpenResourcePlan$ = new Subject<void>();
    protected readonly ReportsPageMeta = ReportsPageMeta;
    protected DepartmentRequired = new BehaviorSubject<boolean>(false);
    protected CommissionLocationRequired = new BehaviorSubject<boolean>(false);
    protected skipSaveChecksExceptCommssionType = false;
    protected parentCommissionInfo$: Observable<string | null>;
    public CommissionColor$: Observable<string>;

    public AdditionalShiftPlanButtons = [
        {
            icon: 'arrows-alt-h' as IconProp,
            iconTransform: { rotate: 135 },
            onClick: (clickEvent) => this.OpenShiftPlan$.next(),
            tooltip: 'vergrößern',
        },
    ];
    public AdditionalResourcePlanButtons = [
        {
            icon: 'arrows-alt-h' as IconProp,
            iconTransform: { rotate: 135 },
            onClick: (clickEvent) => this.OpenResourcePlan$.next(),
            tooltip: 'vergrößern',
        },
    ];
    private fileDialog: MatDialogRef<DaveFileUploadDialogComponent>;
    private onInitTimestamp: Date;
    protected customerLabel$: Observable<string> = this.cls.getSingle$('CustomerSupplier')
    protected customersLabel$: Observable<string> = this.cls.getMultiple$('CustomerSupplier')
    protected customerOnlyLabel$: Observable<string> = this.cls.getSingle$('Customer')
    private hideSuppliers = false;
    constructor(
        private appDialog: AppDialogService,
        private dialog: MatDialog,
        private fb: FormBuilder,
        private store: Store<State>,
        private activatedRoute: ActivatedRoute,
        private routingHistoryService: RoutingHistoryService,
        private router: Router,
        private route: ActivatedRoute,
        private personResolver: PersonResolver,
        private currencyPipe: CurrencyPipe,
        private decimalPipe: DecimalPipe,
        private datePipe: DatePipe,
        public PS: PermissionService,
        arlResolver: AccountsReceivableLedgerCommissionResolver,
        public LS: LoadingService,
        private actions$: Actions,
        private cdr: ChangeDetectorRef,
        protected cls: CustomLabelService,
        private diaryService: DiaryDataService,
        private folderDataService: FolderDataService,
        protected bs: BreakpointObserverService,
        private taskFilterService: TaskFilterService,
        private newReportDialogService: NewReportDialogService,
        private processResolver: ProcessResolver,
        private interruptionEventService: InterruptionEventService,
        @Inject(LOCALE_ID) private locale: string,
        private createArlFromCommissionService: CreateArlFromCommissionService,
        private arlDataService: ArlDataService,
        private toastrService: ToastrService,
        private selectArlDialogService: SelectArlDialogService,
        private departmentService: DepartmentService,
        private commissionService: CommissionService,
        private customizationDataService: CustomizationDataService,
        private commissionResolver: CommissionResolver,
        person2EntityResolver: Person2EntityByEntityIdCommissionResolver,
        private customerDataService: CustomerDataService,
        private ledgerImportDataService: LedgerImportDataService,
    ) {
        this.customizationFunctions$.pipe(first()).subscribe((functions) => {
            if (functions.some(f => CUSTOMIZATION_FUNCTIONS_COMMISSION_SHAREPOINT.some(s => s === f.Slug))) {
                this.CommissionForm.controls.Description.addValidators([sharepointFolderNameValidator(), Validators.required]);
            }
           });
        getFetched$(this.store, getPartnerFetched, getPartner).pipe(take(1)).subscribe((partner) => {
            if(partner?.AdditionalData?.useServicePeriod){
                this.showServicePeriod = true;
            }
        })

        this.ProcessFilterValues$.next({
            [FilterTypes.Status]: processStateValues
                .filter((ps) => ps !== ProcessState.ProcessStateDone && ps !== ProcessState.ProcessStateArchived)
                .map((v) => {
                    return {
                        id: v,
                        label: ProcessStateNames.get(v),
                    };
                }),
        });

        this.subscriptions.push(
            // this.actions$.pipe(ofType(CommissionActionTypes.UpdateMany, CommissionActionTypes.UpdateOne)).subscribe((action) => {
            //     if (action.type === CommissionActionTypes.UpdateMany.type && action.Payload.length === 1) {
            //         this.setCommissionSeen(action.Payload[0].Id);
            //     } else if (action.type === CommissionActionTypes.UpdateOne.type) {
            //         this.setCommissionSeen(action.Payload.Id);
            //     }
            // }),
            ...getCommissionFormAddressSearchSubscriptions(this.CommissionForm, this.store, this.CommissionLocationForm, this.cdr),
            route.queryParamMap.subscribe((q) => {
                if (route.snapshot.queryParams?.documentId && +route.snapshot.queryParams.documentId && +route.snapshot.queryParams.documentId !== this.PreviewedFileId$.value) {
                    this.PreviewedFileId$.next(+route.snapshot.queryParams.documentId);
                }
            }),
            this.store
                .select(getPerson2EntitiesFetched)
                .pipe(
                    distinctUntilChanged(),
                    switchMap((fetched) => {
                        if (!fetched) {
                            return person2EntityResolver.resolve(this.activatedRoute.snapshot);
                        }
                        return of(true);
                    }),
                )
                .subscribe(),
            this.store
                .select(getProcessFetched)
                .pipe(
                    distinctUntilChanged(),
                    tap((fetched) => {
                        if (!fetched) {
                            processResolver.resolve();
                        }
                    }),
                )
                .subscribe(),
        );
        this.bookmarks$ = store.select(getBookmarks);
        this.persons$ = store.select(getPersons);
        PS.Has$(PS.Permissions.GetAccountsReceivableLedgers)
            .pipe(filter(isNotNullOrUndefined), take(1))
            .subscribe((p) => {
                if (p) {
                    arlResolver.resolve(this.activatedRoute.snapshot);
                }
            });

            this.parentCommissionInfo$ = this.parentCommission$.pipe(
                switchMap(parent =>
                    parent
                        ? combineLatest([
                            parent.PartnerOfficeId ? this.store.select(getPartnerOfficeById({ id: parent.PartnerOfficeId })) : of(undefined),
                            parent.DepartmentId ? this.store.select(getDepartmentById({ id: parent.DepartmentId })) : of(undefined),
                            this.Commission$,
                        ]).pipe(
                            map(([office, department, commission]) => {
                                const parts: string[] = [];

                                if (office?.Name && office.Id !== commission.PartnerOfficeId) parts.push(office.Name);
                                if (parent.Description) parts.push(parent.Description);
                                if (parent.Auftragsnummer) parts.push(parent.Auftragsnummer);
                                if (department?.Name) parts.push(department.Name);

                                return parts.join(' | ');
                            }))
                        : of(null)
                )
            );

        this.customizationDataService
            .getFeatures$()
            .pipe(take(1))
            .subscribe((features) => {
                if (features?.includes('hideSuppliersInCommission')) {

                    this.customerSearch = this.customerDataService.createSearchState({
                        onlyCustomers: true,
                    });
                    this.hideSuppliers = true;
                }
            });


    }
    public getCountEreignisse(event) {
        this.EreignissCount = event;
    }
    public DetailListTemplateEntrys: ICommissionDetailListTemplateEntrys = {};

    public StatusData: Observable<IDetailListTemplateData>;
    public ShowStatus = false;
    public CommentFileUploadParams$: Observable<FileUploadParams>;
    public UploadFolderId: number;
    public InvoiceEditorMeta = InvoiceEditorMeta;
    public BookingPositionMetaIcon = BookingPositionMetaIcon;
    public statusDropdown = new FormControl<number>(null);
    public SearchLocationForm = new FormControl<SelectSearchData>(null);
    public CommissionForm = createCommissionFormGroup(null); // validator wird ggf später im constructor gesetzt
    public ChronikPath = HistoryMeta.Path;
    public ChronikIcon = HistoryMeta.Icon;
    public StatisticPath = StatisticsPageMeta.Path;
    public DMSPath = DMSPageMeta.Path;
    public DMSIcon = DMSPageMeta.Icon;
    public CustomerPath = CustomerAdministrationMeta.Path;
    public AkkordMeta = PieceworkCalculationPageMeta;
    public CustomerIcon = CustomerAdministrationMeta.Icon;
    public Editing$ = new BehaviorSubject<boolean>(false);
    public Save$ = new Subject<{ wizardPage: number | undefined, skipValidation?: boolean }>();
    public SaveStatus$ = new Subject<void>();
    public AllEventsMetaPath = AllEventsMeta.Path;
    public SharedCommissions$ = this.store.select(getSharedCommissions);
    public Partner$ = this.store.select(getPartner);
    protected isTsb$ = this.Partner$.pipe(map((p) => p.PartnerTypeId === PartnerTypeEnum.TSB));



    private readonly OPTIONAL_CHILD_COMMISSION_COLUMNS: Array<keyof CommissionEntity | 'status' | 'createdAt' | 'PartnerOffice' | 'Department'> = ['InterneNummer', 'createdAt'];
    private readonly DEFAULT_OPTIONAL_CHILD_COMMISSION_COLUMNS: Array<keyof CommissionEntity | 'status' | 'createdAt' | 'PartnerOffice' | 'Department'> = ['InterneNummer', 'createdAt'];

    protected childCommissionColumnSettings$ = getFetched$(this.store, getSettingFetched, getSetting).pipe(
        map((settings) => {
            const saved = settings?.ChildCommissionsListOptionalDisplayedColumns;
            return Array.isArray(saved) ? saved : this.DEFAULT_OPTIONAL_CHILD_COMMISSION_COLUMNS;
        })
    );


    protected childCommissionColumns$: Observable<Array<keyof CommissionEntity | 'status' | 'createdAt' | 'PartnerOffice' | 'Department'>> = combineLatest([
        this.isTsb$,
        this.childCommissionColumnSettings$,
    ]).pipe(
        map(([isTsb, optionalColumns]) => {
            const columns: Array<keyof CommissionEntity | 'status' | 'createdAt' | 'PartnerOffice' | 'Department'> = [];

            if (!isTsb) columns.push('Auftragsnummer');
            if (optionalColumns.includes('InterneNummer')) columns.push('InterneNummer');
            columns.push('Description');
            if (optionalColumns.includes('PartnerOffice')) columns.push('PartnerOffice');
            if (optionalColumns.includes('Department')) columns.push('Department');
            if (optionalColumns.includes('createdAt')) columns.push('createdAt');
            columns.push('status');

            return columns;
        }),
    );

    protected updateChildCommissionColumn(column: string) {
        firstValueFrom(this.childCommissionColumnSettings$).then(current => {
            const currentArray = Array.isArray(current) ? current : this.OPTIONAL_CHILD_COMMISSION_COLUMNS;
            const updated = currentArray.includes(column)
                ? currentArray.filter(c => c !== column)
                : [...currentArray, column];
            this.store.dispatch(new ChangeSettings({ ChildCommissionsListOptionalDisplayedColumns: updated }));
        });
    }

    public Commission$: Observable<CommissionEntity> = this.activatedRoute.paramMap.pipe(
        map((paramMap) => +paramMap.get('commissionId')),
        distinctUntilChanged(),
        switchMap((commissionId) => this.store.select(getCommissionById({ id: commissionId }))),
        tap((commission) => {
            if (!commission) {
                console.error('Could not find CommissionEntity');
            }
        }),
        filter(isNotNullOrUndefined),
        tap(() => this.cdr.detectChanges()), // ugly fix, repariert das in left und right content vom app-detail-view-template beim start was drin steht
        shareReplay({ refCount: true, bufferSize: 1 }),
    );
    protected parentCommission$: Observable<CommissionEntity | null> = merge(
        this.Commission$.pipe(map(c => c.ParentId)),
        this.CommissionForm.controls.ParentCommission.valueChanges.pipe(map(v => v?.Id)),
    ).pipe(
        distinctUntilChanged(),
        switchMap(id => id ? this.store.select(getCommissionById({ id })) : of(null)),
    );
    protected department$ = this.Commission$.pipe(
        map((c) => c?.DepartmentId),
        distinctUntilChanged(),
        switchMap(id => id ? this.store.select(getDepartmentById({id})) : of(null)),
    )
    protected partnerOfficeInfo$ = combineLatest([
        this.Commission$.pipe(
            map(c => c?.PartnerOfficeId),
            distinctUntilChanged()
        ),
        this.store.select(getOwnPartnerOffices)
    ]).pipe(
        map(([partnerOfficeId, partnerOffices]) => ({
            count: partnerOffices.length,
            partnerOffice: partnerOffices.find(po => po.Id === partnerOfficeId) ?? null
        }))
    );
    public SearchBarActive = false;
    public SearchForm = new FormControl<string>('');
    public TaskBoardSort: ITaskBoardSort = { sortBy: 'endDate', direction: 'dsc' };
    public TaskBoardFilterValues$: BehaviorSubject<IEventFilterType> = getEventFilterValues();
    protected taskBoardFilter$: Observable<TaskBoardFilter> = combineLatest([
        this.TaskBoardFilterValues$,
        this.Commission$.pipe(
            map((c) => c?.Id),
            distinctUntilChanged(),
        ),
    ]).pipe(
        map(([v, commissionId]) => ({
            CommissionIds: commissionId ? [commissionId] : null,
            UserId: v[FilterTypes.UserId]?.map((u) => +u.id) || null,
            AutorId: v[FilterTypes.AutorId]?.map((u) => +u.id) || null,
            Priority: v.priority?.length ? v.priority.map((p) => +p.id as ITaskPriority) : null,
            MinEventEndDate: v[FilterTypes.EndDate]?.from ? v[FilterTypes.EndDate].from.toDate() : null,
            MaxEventEndDate: v[FilterTypes.EndDate]?.to ? v[FilterTypes.EndDate].to.toDate() : null,
            MilestoneIds: v[FilterTypes.Milestones]?.map((u) => u.id) || null,
            CategoryIds: v[FilterTypes.EventCategory]?.map((u) => +u.id) || null,
        })),
    );
    public TaskBoardFilterSettings$: Observable<FilterOption[]> = this.taskFilterService
        .filterSettingsWithMilestones$(
            this.Commission$.pipe(
                map((c) => c?.Id),
                distinctUntilChanged(),
            ),
        )
        .pipe(map((settings) => settings.filter((s) => s.Name !== FilterTypes.CommissionId)));
    public TaskBoardFilterAmount$ = this.TaskBoardFilterValues$.pipe(map(clacEventFilterAmount), shareReplay({ refCount: true, bufferSize: 1 }));

    protected showWizard$ = this.Commission$.pipe(
        switchMap((c) =>
            isNotNullOrUndefined(c.AdditionalData?.wizardPage)
                ? combineLatest([
                    this.store.select(getCommissionTypeById({ id: c.CommissionTypeId })),
                    this.store.select(getPartner),
                ]).pipe(
                    map(([ct, partner]) => {
                        const steps = partner.Settings?.WizardSteps?.length
                            ? partner.Settings.WizardSteps
                            : ct?.AdditionalData?.WizardSteps;
                        return steps ? steps.length >= c.AdditionalData.wizardPage : true;
                    })
                )
                : of(false),
        ),
    );
    public ChildCommissions$: Observable<MatTableDataSource<DaveListCardcolumnProperties<Partial<CommissionEntity>>>> = this.Commission$.pipe(
        distinctUntilChanged((a, b) => a.Id === b.Id),
        switchMap((c) =>
            combineLatest([this.store.select(getCommissions), this.store.select(getStatusFromBackoffice), this.store.select(getPartnerOffices), this.store.select(getDepartments)]).pipe(
                map(([commissions, backofficeStates, partnerOffices, departments]) =>
                    commissions
                        .filter((commission) => commission.ParentId === c.Id)
                        .map((c) => {
                            const StatusBackoffice: StatusFromBackofficeEntity = backofficeStates.find((s) => s.Id === c.StatusBackofficeId);
                            const Department = departments.find((d) => d.Id === c?.DepartmentId)?.Name;
                            const PartnerOffice = partnerOffices.find((p) => p.Id === c?.PartnerOfficeId)?.Name;
                            return {
                                ...c,
                                Department: Department,
                                PartnerOffice: PartnerOffice,
                                status: StatusBackoffice?.Name,
                                createdAt: formatDate(c.CreatedAt, 'mediumDate', 'de-DE'),
                                cssStyle: `--app-clickable-background-color: ${c.GetBackgroundColor(StatusBackoffice?.IsCompleted, StatusBackoffice?.Color)};`,
                                cssClass: 'app-clickable-background',
                            };
                        }),
                ),
            ),
        ),
        distinctUntilChanged((a, b) => a.length === b.length && a.every((v, i) => v.Id === b[i].Id && v.UpdatedAt.getTime() === b[i].UpdatedAt.getTime())),
        map((commissions) => new MatTableDataSource(commissions)),
    );
    protected departmentLabel$ = this.cls.getSingle$('ExecutingDepartment').pipe(
        map(label => label || 'Abteilung')
    );

    protected childCommissionExpanded =  false;
    protected ChildCommissionsCount$ = this.ChildCommissions$.pipe(
        map(ds => ds.data.length)
    );
    public GetRouteForCommissionImport = ({ Id }) => ['/', CommissionMeta.Path, Id];
    public CommissionAddress$ = this.Commission$.pipe(map((c) => getAddressString(c)));
    public CommissionMeta = CommissionMeta;
    private eventTypeId$ = (eventTypeName: EventTypeNamesEnum) => {
        return getFetched$(this.store, getEventTypeFetched, getEventTypes).pipe(
            map((eventTypes) => eventTypes.find((e) => e.Name === eventTypeName)?.Id),
            distinctUntilChanged(),
            tap(et => {
                if (!et) {
                    throw new Error('app-detail-commission: EventType not found: ' + eventTypeName);
                }
            }),
        );
    };

    public MangelId$ = this.eventTypeId$(EventTypeNamesEnum.Erschwernis);
    public MangelanzeigenId$ = this.eventTypeId$(EventTypeNamesEnum.Mangelanzeige);
    public BedenkenanzeigenId$ = this.eventTypeId$(EventTypeNamesEnum.Bedenkenanzeige);
    public NachnahmenId$ = this.eventTypeId$(EventTypeNamesEnum.Zusatzarbeit);
    public auffaelligkeitId$ = this.eventTypeId$(EventTypeNamesEnum.Auffaeligkeit);
    public documentationId$ = this.eventTypeId$(EventTypeNamesEnum.Dokumentation);
    public regiearbeitId$ = this.eventTypeId$(EventTypeNamesEnum.Regiearbeit);

    private commissionCanHaveChildren$ = this.Commission$.pipe(
        map((c) => ({ CommissionTypeId: c.CommissionTypeId, CommissionId: c.Id })),
        distinctUntilChanged((a, b) => a.CommissionId === b.CommissionId && a.CommissionTypeId === b.CommissionTypeId),
        switchMap(({ CommissionTypeId }) => this.store.select(getCommissionTypeById({ id: CommissionTypeId })).pipe(map((ct) => ct?.AdditionalData?.CanHaveChildCommissions))),
    )
    public ViewStyleConfig$: Observable<{ left: ViewStyleConfig[]; right: ViewStyleConfig[] }> = combineLatest([
        this.Commission$.pipe(
            map((c) => ({ CommissionTypeId: c.CommissionTypeId, CommissionId: c.Id })),
            distinctUntilChanged((a, b) => a.CommissionId === b.CommissionId && a.CommissionTypeId === b.CommissionTypeId),
            switchMap(({ CommissionTypeId, CommissionId }) => this.store.select(getCommissionTypeById({ id: CommissionTypeId })).pipe(map((ct) => ({ CommissionType: ct, CommissionId })))),
        ),

        this.store.select(getViewStyleSetting).pipe(
            filter(isNotNullOrUndefined),
            map((vss) => vss.filter((v) => v.View === ViewStyleSettingViewEnum.Commission)),
        ),
        combineLatest([
            this.store.select(getUserToCommissionFetched).pipe(
                filter((v) => !!v),
                switchMap(() =>
                    combineLatest([
                        this.Commission$.pipe(
                            map((c) => c.Id),
                            distinctUntilChanged(),
                        ),
                        this.store.select(getUser).pipe(
                            map((c) => c.Id),
                            distinctUntilChanged(),
                        ),
                    ]),
                ),
                switchMap(([commissionId, userId]) => this.store.select(getUserToCommissions).pipe(map((u2c) => u2c.filter((u) => u.CommissionId === commissionId && u.UserId === userId)))),
            ),
            this.store.select(getEntityRoleFetched).pipe(
                filter((v) => !!v),
                switchMap(() => this.store.select(getEntityRole)),
                map((roles) => roles.filter((r) => r.Entity === EntityTypesEnum.Commission)),
            ),
        ]).pipe(map(([u2c, roles]) => roles.filter((r) => u2c.some((u) => u.RoleId === r.Id)))),
        this.store.select(getUser),
        this.PS.Has$(this.PS.Permissions.AccessGeneratedDocumentsArea),
        this.PS.permissions$,
        this.store.select(getUserProducts),
    ]).pipe(
        map(([{ CommissionId, CommissionType }, vss, roles, user, commissionPermission, userPermissions, products]) => {
            let settings = selectViewStyleSetting(vss, ViewStyleSettingViewEnum.Commission, CommissionType?.Id, CommissionId);
            let v = CommissionType?.AdditionalData?.CanHaveChildCommissions ? settings.Config.config : removeFromViewStyle(settings.Config.config, 'childCommissionsTemplate');
            const overviewPermission = roles.some((r) => r.Permissions.some((p) => p.name === EntityRolePermissionNameEnum.GetCommissionOverview));
            const customerRole = user.Roles.some((r) => r === UserRoles.CustomerManagementUser || r === UserRoles.CustomerManagementAdmin);
            if (!commissionPermission) {
                v = removeFromViewStyle(v, 'reportsTabGroupTemplate');
                this.ShowCommissionButtons = false;
            }
            if (!customerRole) {
                v = removeFromViewStyle(v, 'entityHistoryTemplate');
                v = removeFromViewStyle(v, 'groupListTemplate');
                this.showCustomerButtons = false;
            }

            const allPermissions: Array<Permissions | EntityRolePermissionNameEnum> = [];
            userPermissions.forEach((p) => {
                if (!allPermissions.includes(p.Name)) {
                    allPermissions.push(p.Name);
                }
            });
            roles.forEach((r) => {
                r.Permissions.forEach(p => {
                    if (!allPermissions.includes(p.name)) {
                        allPermissions.push(p.name);
                    }
                });
            });

            if (!allPermissions.includes(Permissions.GetCommissionOverview)) {
                v = removeFromViewStyle(v, 'commissionOverviewTemplate');
            }

            if (!allPermissions.includes(Permissions.GetServiceHistory)) {
                v = removeFromViewStyle(v, 'eventList');
            }

            if (!allPermissions.includes(Permissions.GetERPResources)) {
                v = removeFromViewStyle(v, 'resourceListTemplate');
                v = removeFromViewStyle(v, 'resourceScheduleListeTemplate');
                v = removeFromViewStyle(v, 'materialListTemplate');
            }
            if (!allPermissions.includes(Permissions.GetProjectChanges)) {
                v = removeFromViewStyle(v, 'entityHistoryTemplate');
            }
            if (!allPermissions.includes(Permissions.GetStoerungen)) {
                v = removeFromViewStyle(v, 'auffaelligkeitListTemplate');
                v = removeFromViewStyle(v, 'dokumentationListTemplate');
                v = removeFromViewStyle(v, 'regiearbeitenListTemplate');
                v = removeFromViewStyle(v, 'nachnahmenListTemplate');
                v = removeFromViewStyle(v, 'mangelListTemplate');
                v = removeFromViewStyle(v, 'mangelanzeigeListTemplate');
                v = removeFromViewStyle(v, 'bedenkenanzeigeListTemplate');
            }
            if (!allPermissions.includes(Permissions.GetExternalPerson)) {
                v = removeFromViewStyle(v, 'personList');
                v = removeFromViewStyle(v, 'groupListTemplate');
            }
            if (!allPermissions.includes(Permissions.GetLedgerImports)) {
                v = removeFromViewStyle(v, 'ledgerImportListTemplate');
            }
            if (!allPermissions.includes(Permissions.GetAccountsReceivableLedgers)) {
                v = removeFromViewStyle(v, 'bookingPositionList');
                v = removeFromViewStyle(v, 'hiddenBookingPositionList');
            }
            if (!allPermissions.includes(Permissions.GetFileExplorer)) {
                v = removeFromViewStyle(v, 'fileExplorer');
                v = removeFromViewStyle(v, 'additionalFoldersFileExplorer');
            }
            if (!allPermissions.includes(Permissions.GetTickets)) {
                v = removeFromViewStyle(v, 'blueprintTemplate');
            }
            if (!allPermissions.includes(Permissions.GetChat)) {
                v = removeFromViewStyle(v, 'commentsTemplate');
            }
            if (!allPermissions.includes(Permissions.CanSeeProcesses)) {
                v = removeFromViewStyle(v, 'processListTemplate');
            }
            if (!products.some(p => p.Name === ProductNames.Task)) {
                v = removeFromViewStyle(v, 'taskBoard');
            }

            if (!allPermissions.includes(Permissions.SeeEmployeeresourceSchedule)) {
                v = removeFromViewStyle(v, 'shiftplan');
            }
            if (!allPermissions.includes(Permissions.SeeResourceSchedule)) {
                v = removeFromViewStyle(v, 'resourceplan');
            }

            return v;
        }),
        distinctUntilChanged((a, b) => JSON.stringify(a) === JSON.stringify(b)),
        map((conf) => {
            console.warn('##################');
            console.log(sortViewStyleConfig(conf.filter((c) => c.right).slice()));
            return {
                left: sortViewStyleConfig(conf.filter((c) => !c.right).slice()),
                right: sortViewStyleConfig(conf.filter((c) => c.right).slice()),
            };
        }),
    );
    public NavigateChronikFilter$ = this.Commission$.pipe(
        map((com) =>
            TimelineViewComponent.getFilterQueryParam({
                [FilterTypes.Commissions]: [
                    {
                        id: com.Id,
                        label: com.DisplayName,
                    },
                ],
            }),
        ),
    );
    public IsGericht$ = combineLatest([this.Commission$, this.store.select(getCommissionTypes)]).pipe(
        map(([commission, comissionTypes]) =>
            comissionTypes
                .find((ct) => ct.Id === commission.CommissionTypeId)
                ?.Name.toLowerCase()
                .includes('gericht'),
        ),
    );
    public CommissionType$ = this.Commission$.pipe(switchMap((c) => (c?.CommissionTypeId ? this.store.select(getCommissionTypeById({ id: c.CommissionTypeId })) : null)));
    public HasDiary$ = combineLatest([this.Commission$, this.store.select(getCommissionTypes)]).pipe(
        map(([commission, comissionTypes]) => !!comissionTypes.find((ct) => ct.Id === commission.CommissionTypeId)?.AdditionalData?.ConstructionDiary),
    );

    public Versicherungsnehmer$: Observable<PersonEntity> = combineLatest([this.store.select(getPersons), this.store.select(getComplaintTypes), this.store.select(getPerson2Entities), this.Commission$]).pipe(
        map(([persons, complaintTypes, p2e, commission]) => {
            const personTypeId = complaintTypes.find((ct) => ct.Name.toLowerCase().includes('versicherungsnehmer'))?.Id;
            const pId = p2e?.find((p) => p.EntityType === Person2EntityEntityTypeEnum.Commission && p.EntityId === commission.Id && personTypeId === p.ComplaintTypeId)?.PersonId;
            return persons.find((p) => p.Id === pId);
            // return persons?.find(p => p.CommissionId === commission.Id && p.PersonTypeId === personTypeId);
        }),
    );
    public beteiligtePersonenComplainTypeId$ = this.store.select(getComplaintTypes).pipe(map((complaintTypes) => complaintTypes.find((ct) => ct.Name.toLowerCase().includes('beteiligte person'))?.Id));
    public judgePersonenComplainTypeId$ = this.store.select(getComplaintTypes).pipe(map((complaintTypes) => complaintTypes.find((ct) => ct.Name.toLowerCase().includes('vorsitzender'))?.Id));
    public klagenderPersonenComplainTypeId$ = this.store.select(getComplaintTypes).pipe(map((complaintTypes) => complaintTypes.find((ct) => ct.Name.toLowerCase().includes('klagender'))?.Id));
    public beklagtePersonenComplainTypeId$ = this.store.select(getComplaintTypes).pipe(map((complaintTypes) => complaintTypes.find((ct) => ct.Name.toLowerCase().includes('beklagter'))?.Id));

    displayedColumnsProcessList: Array<keyof typeof this.TableConfigProcessList> = ['ActiveStep', 'Name', 'Editor', 'EndDate'];
    TableConfigProcessList = {
        ActiveStep: 'Prozessschritt',
        Name: 'Prozessname',
        Editor: 'Bearbeiter',
        EndDate: 'Frist',
        Id: 'Id',
        ProcessTemplateId: 'ProcessTemplateId',
    };

    formatUserName(displayName: string): string {
        if (!displayName) {
            return '';
        }

        const [lastName, firstName] = displayName.split(',').map((namePart) => namePart.trim());

        if (!lastName || !firstName) {
            return displayName;
        }

        const formattedName = `${firstName.charAt(0)}${lastName.substring(0, 3)}`;

        return formattedName;
    }

    public ProcessFilterValues$: BehaviorSubject<IProcessFilterType> = new BehaviorSubject<IProcessFilterType>({
        [FilterTypes.Status]: [],
    });

    public ProcessFilterSettings: FilterOption[] = [
        {
            Name: FilterTypes.Status,
            Type: FILTER_TYPE_SEARCH_MULTI_SELECT,
            Label: 'Status',
            // Icon: CommissionMeta.Icon,
            Values: processStateValues.map((m) => ({
                label: ProcessStateNames.get(m),
                id: m,
            })) as IFilterTypeSearchMultiSelectValue[],
        },
    ];

    public ProcessFilterAmount$ = this.ProcessFilterValues$.pipe(
        map((filterValues: IProcessFilterType) => {
            return filterValues[FilterTypes.Status].length;
        }),
    );

    public ShowProcessList$: Observable<ProcessTemplateTableData[]> = combineLatest([this.store.select(getProcesses), this.Commission$, this.store.select(getEmployees), this.store.select(getTasks)]).pipe(
        map(([processes, commission, users, tasks]) => {
            const processList = processes?.filter((p) => p.CommissionId === commission.Id && p.DeletedAt === null);

            return processList.map((p) => {
                const activeStepTaskId = isNotNullOrUndefined(p.ActiveStep) && p.Steps[p.ActiveStep]?.TaskId;
                if (activeStepTaskId != null) {
                    const task = tasks?.find((e) => e.Id === activeStepTaskId);
                    if (task) {
                        const bearbeiter = task?.UserIds?.length
                            ? task.UserIds.map((id) => {
                                  const user = users.find((user) => user.UserId === id);
                                  const displayName = user?.DisplayName;
                                  return displayName ? this.formatUserName(displayName) : null;
                              })
                                  .filter(isNotNullOrUndefined)
                                  .join(', ')
                            : null;

                        return {
                            ActiveStep: p.ActiveStep,
                            State: p.State,
                            Name: p.Name,
                            Editor: bearbeiter || 'Unbekannt',
                            EndDate: formatDate(p.CreatedAt, 'shortDate', this.locale),
                            Id: p.Id,
                            ProcessTemplateId: p.ProcessTemplateId,
                            cssClass: p.GetBackgroundColorClass(),
                        };
                    }
                }
                return {
                    ActiveStep: p.ActiveStep,
                    State: p.State,
                    Name: p.Name,
                    Editor: '',
                    EndDate: formatDate(p.CreatedAt, 'shortDate', this.locale),
                    Id: p.Id,
                    ProcessTemplateId: p.ProcessTemplateId,
                    cssClass: p.GetBackgroundColorClass(),
                };
            });
        }),
        switchMap((processListEntries) =>
            this.ProcessFilterValues$.pipe(
                map((filterValues) => {
                    let filteredProcessList = processListEntries;

                    const selectedProcessStates = filterValues[FilterTypes.Status].map((s) => s.id);

                    if (selectedProcessStates.length > 0) {
                        filteredProcessList = filteredProcessList.filter((p) => selectedProcessStates.includes(p.State));
                    }

                    return filteredProcessList;
                }),
            ),
        ),
    );

    //     = combineLatest([this.store.select(getPersons), this.store.select(getPersonTypes), this.Commission$, this.store.select(getPerson2Entities)]).pipe(
    //     map(([persons, personTypes, commission, p2es]) => {
    //         const pId: Person2EntityEntity[] = p2es?.filter((p) => p.EntityType === Person2EntityEntityTypeEnum.Commission && p.EntityId === commission.Id) || [];
    //         return persons?.filter(
    //             (p) =>
    //                 pId.some(p2e => p.Id === p2e.PersonId) &&
    //                 personTypes
    //                     .find((pt) => pt.Id === p.PersonTypeId)
    //                     ?.Name.toLowerCase()
    //                     .includes('vorsitzender'),
    //         );
    //     }),
    // );

    public ShowGenFilesList$ /*: Observable<{ type: GeneratedDocumentsTypeEntity; Name: string; Id: number; date: string; label: string;  }[]>*/ = combineLatest([
        this.store.select(getGeneratedDocumentsSortedByCreatedAt),
        this.store.select(getGeneratedDocumentsTypes),
        this.Commission$,
    ]).pipe(
        filter((v) => v.every(isNotNullOrUndefined)),
        map(([genFiles, genFilesType, commission]) => {
            const ret = genFiles
                .filter((e) => e.CommissionId === commission.Id)
                .map((e) => ({
                    type: genFilesType?.find((gft) => gft.Id === e.GeneratedDocumentsTypeId),
                    date: formatDate(e.CreatedAt, 'shortDate', 'de-DE'),
                    Name: e.Name || 'Platzhalter',
                    Id: e.Id,
                    suffixButton: e.DocumentIdFromPdf
                        ? {
                              icon: DMSPageMeta.Icon,
                              tooltip: 'Zum Dokument',
                              onClick: (args: any) => {
                                  this.PreviewedFileId$.next(e.DocumentIdFromPdf);
                                  this.PreviewOpen = true;
                              },
                          }
                        : null,
                }))
                .map((v) => Object.assign(v, { label: `${v.type?.Name || 'Typ'} ${v.Name} ${v.date}` }));
            const diaryReports: typeof ret = [],
                zusatzReports: typeof ret = [],
                bedenkenReports: typeof ret = [],
                mangelReports: typeof ret = [],
                otherReports: typeof ret = [],
                auffaelligkeit: typeof ret = [],
                dokumentation: typeof ret = [],
                regiearbeit: typeof ret = [],
                erschwernisReports: typeof ret = [];
            ret.forEach((e) => {
                if (e.type?.Slug === GeneratedDocumentsTypeSlugs.constructionDiary) {
                    diaryReports.push(e);
                } else if (e.type?.Slug === GeneratedDocumentsTypeSlugs.zusatzarbeit) {
                    zusatzReports.push(e);
                } else if (e.type?.Slug === GeneratedDocumentsTypeSlugs.bedenken) {
                    bedenkenReports.push(e);
                } else if (e.type?.Slug === GeneratedDocumentsTypeSlugs.mangel) {
                    mangelReports.push(e);
                } else if (e.type?.Slug === GeneratedDocumentsTypeSlugs.auffaelligkeit) {
                    auffaelligkeit.push(e);
                } else if (e.type?.Slug === GeneratedDocumentsTypeSlugs.dokumentation) {
                    dokumentation.push(e);
                } else if (e.type?.Slug === GeneratedDocumentsTypeSlugs.regiearbeit) {
                    regiearbeit.push(e);
                } else if (e.type?.Slug === GeneratedDocumentsTypeSlugs.erschwernis) {
                    erschwernisReports.push(e);
                } else {
                    otherReports.push(e);
                }
            });
            return {
                diaryReports,
                zusatzReports,
                bedenkenReports,
                mangelReports,
                erschwernisReports,
                auffaelligkeit,
                otherReports,
                dokumentation,
                regiearbeit,
            };
        }),
        shareReplay({ bufferSize: 1, refCount: true }),
    );
    DiaryReports$ = this.ShowGenFilesList$.pipe(map((v) => v.diaryReports));
    ZusatzReports$ = this.ShowGenFilesList$.pipe(map((v) => v.zusatzReports));
    BedenkenReports$ = this.ShowGenFilesList$.pipe(map((v) => v.bedenkenReports));
    MangelReports$ = this.ShowGenFilesList$.pipe(map((v) => v.mangelReports));
    erschwernisReports$ = this.ShowGenFilesList$.pipe(map((v) => v.erschwernisReports));
    auffaelligkeitReports$ = this.ShowGenFilesList$.pipe(map((v) => v.auffaelligkeit));
    dokumentationReports$ = this.ShowGenFilesList$.pipe(map((v) => v.dokumentation));
    regiearbeitReports$ = this.ShowGenFilesList$.pipe(map((v) => v.regiearbeit));
    OtherReports$ = this.ShowGenFilesList$.pipe(map((v) => v.otherReports));

    public ShowSelectedPartners$ = combineLatest([this.store.select(getSharedCommissions), this.store.select(getPartners), this.Commission$]).pipe(
        map(([sharedCommissions, partners, commission]) =>
            partners?.filter((p) => isNotNullOrUndefined(sharedCommissions?.filter((sC) => sC.CommissionId === commission.Id)?.find((sC) => sC.PartnerLinkedId === p.Id))).filter((p) => p !== undefined),
        ),
    );
    public Folder$: Observable<FolderEntity> = this.Commission$.pipe(
        distinctUntilChanged((a, b) => a.Id === b.Id),
        switchMap((commission) => this.folderDataService.getFolderFromEntity(commission.Id, FolderTypes.commission)),
        filter(isNotNullOrUndefined),
        shareReplay({ refCount: true, bufferSize: 1 }),
    );


    private sharepointToken$ = getMySharepointToken(this.store);

    private sharepointFolders$ = this.Commission$.pipe(
        map(c => c.SharepointRootFolders || []),
        // D277-6035"Anfrageordner ausblenden"
        map(folders => folders.filter(f => f.Type !== SharepointRootFolderType.request)),
    );

    private customizationFunctions$ = this.customizationDataService.getFunctions$().pipe(shareReplay({refCount: true, bufferSize: 1}));

    protected missingSharepointFolders$: Observable<{tooltip: string, customFunctionSlug: CustomFunctionsSlug}[]> = combineLatest([
        this.sharepointToken$,
        this.sharepointFolders$,
        this.Commission$,
        this.commissionCanHaveChildren$,
    ]).pipe(
        switchMap(([token, folders, commission, isGrossProject]) => {
            const missingTypes: SharepointRootFolderType[] = ((commission.ParentId === null && isGrossProject) ? [SharepointRootFolderType.request, SharepointRootFolderType.centralProjektFiles, SharepointRootFolderType.constructionFiles] : [ SharepointRootFolderType.constructionFiles]).filter(type => folders.every(f => f.Type !== type));
            if ((!!token) && missingTypes.length > 0) {
                return this.customizationFunctions$.pipe(map(availableFunctions => {
                    const ret: {tooltip: string, customFunctionSlug: CustomFunctionsSlug}[] = [];
                    // D277-6035"Anfrageordner ausblenden"
                    // if (missingTypes.includes(SharepointRootFolderType.request) && availableFunctions.some(f => f.Slug === CustomFunctionsSlug.createSharepointCommissionRequestFolder)) {
                    //     ret.push({tooltip: availableFunctions.find(f => f.Slug === CustomFunctionsSlug.createSharepointCommissionRequestFolder).Name, customFunctionSlug: CustomFunctionsSlug.createSharepointCommissionRequestFolder});
                    // }
                    if (missingTypes.includes(SharepointRootFolderType.centralProjektFiles) && availableFunctions.some(f => f.Slug === CustomFunctionsSlug.createSharepointCommissionCentralProjectFilesFolder)) {
                        ret.push({tooltip: availableFunctions.find(f => f.Slug === CustomFunctionsSlug.createSharepointCommissionCentralProjectFilesFolder).Name, customFunctionSlug: CustomFunctionsSlug.createSharepointCommissionCentralProjectFilesFolder});
                    }
                    if (missingTypes.includes(SharepointRootFolderType.constructionFiles) && availableFunctions.some(f => f.Slug === CustomFunctionsSlug.createSharepointCommissionConstructionFilesFolder)) {
                        ret.push({tooltip: availableFunctions.find(f => f.Slug === CustomFunctionsSlug.createSharepointCommissionConstructionFilesFolder).Name, customFunctionSlug: CustomFunctionsSlug.createSharepointCommissionConstructionFilesFolder});
                    }
                    return ret;
                }))
            } else {
                return of([] as {tooltip: string, customFunctionSlug:CustomFunctionsSlug}[]);
            }
        })
    );

    protected readonly SettingsPageMeta = SettingsPageMeta;
    protected readonly SharepointSettingsMeta = SharepointSettingsMeta;
    protected additionalRootFolders$ = combineLatest([
        this.sharepointFolders$,
        this.parentCommission$,
        this.sharepointToken$,
    ]).pipe(
        map(([folders, parent, token]) => {
            const ret:  SharepointRootFolder[] = folders.slice();
            if (isNotNullOrUndefined(parent) && parent?.SharepointRootFolders.length !== 0) {
                ret.push(...parent.SharepointRootFolders.filter(f => /*D277-6035"Anfrageordner ausblenden" f.Type === SharepointRootFolderType.request ||*/ f.Type === SharepointRootFolderType.centralProjektFiles));
            }
            return ret.map(f => ({...f, hasRequiredToken: !!token}));
        }),
        map(folders => folders.map(f => ({
            folder: f,
            sort: f.Type == SharepointRootFolderType.request ? 3 : f.Type == SharepointRootFolderType.centralProjektFiles ? 2 : f.Type == SharepointRootFolderType.constructionFiles ? 1 : 4
        }))),
        map(folders => folders.sort((a, b) => a.sort - b.sort)),
        map(folders => folders.map(f => f.folder)),
    );



    public FolderId$: Observable<number> = this.Folder$.pipe(
        filter(isNotNullOrUndefined),
        map((folder) => folder.Id),
        distinctUntilChanged(),
    );
    protected userToCommissionFromCommission$ = this.Commission$.pipe(
        switchMap((c) => this.store.select(getUserToCommissions).pipe(map((u2cs) => u2cs.filter((u2c) => u2c.CommissionId === c.Id)))),
        shareReplay({ refCount: true, bufferSize: 1 }),
    );
    public IamAssignee$ = this.Commission$.pipe(filter(c=> !!c?.Id),switchMap(c => this.commissionService.iamAssignee$(c.Id)));
    public CommissionEntityRoles$: Observable<EntityRoleEntity[]> = this.Commission$.pipe(filter(c=> !!c?.Id),switchMap(c => this.commissionService.entityRoles$(c.Id)));
    public CommissionEntityRolePermissions$ = this.CommissionEntityRoles$.pipe(
        map((er) => er?.map((e) => e?.Permissions).flat()),
        shareReplay({ bufferSize: 1, refCount: true }),
    );
    public DisableStatusButton$ = this.CommissionEntityRolePermissions$.pipe(map((permissions) => !permissions?.some((p) => p.name === EntityRolePermissionNameEnum.GetStatusButtonCommission)));
    public DisableMailButton$ = this.CommissionEntityRolePermissions$.pipe(map((permissions) => !permissions?.some((p) => p.name === EntityRolePermissionNameEnum.GetSendEmailButtonCommission)));
    public DisableAddEventButton$ = this.CommissionEntityRolePermissions$.pipe(map((permissions) => !permissions?.some((p) => p.name === EntityRolePermissionNameEnum.GetAddEventButtonCommission)));

    public DeleteMileStones$ = this.CommissionEntityRolePermissions$.pipe(map((permissions) => permissions?.some((p) => p.name === EntityRolePermissionNameEnum.DeleteCommissionMilestone)));
    public EditMileStone$ = this.CommissionEntityRolePermissions$.pipe(map((permissions) => permissions?.some((p) => p.name === EntityRolePermissionNameEnum.EditCommissionMilestone)));
    public CreateMileStones$ = this.CommissionEntityRolePermissions$.pipe(map((permissions) => permissions?.some((p) => p.name === EntityRolePermissionNameEnum.CreateCommissionMilestone)));


    hasPermissionOrEntityPermission$ = (permissionName: EntityRolePermissionNameEnum | Permissions) => {
        return this.PS.Has$(permissionName as Permissions).pipe(switchMap(hasPermission => hasPermission ? of(true) : this.CommissionEntityRolePermissions$.pipe(map((permissions) => !!permissions?.some((p) => p.name === permissionName)))));
    }
    public canCreateGeneratedDocument$ = this.hasPermissionOrEntityPermission$(Permissions.CreateBericht);
    public canEditCommissionUsers$ = this.hasPermissionOrEntityPermission$(Permissions.EditRoleCommissionManagement);
    public canGetMilestones$ = this.hasPermissionOrEntityPermission$(Permissions.GetMilestones);
    public canEditCommission$ = this.hasPermissionOrEntityPermission$(Permissions.EditCommission);
    public canDeleteCommission$ = this.hasPermissionOrEntityPermission$(Permissions.DeleteCommission);
    public canCreateTask$ = this.hasPermissionOrEntityPermission$(Permissions.CreateEvents);
    public canGetAkkord$ = this.hasPermissionOrEntityPermission$(Permissions.GetAkkord);
    public canBillCommission$ = this.hasPermissionOrEntityPermission$(Permissions.CreateLedgerImports);
    public canEditStatusFromBackoffice$ = this.hasPermissionOrEntityPermission$(Permissions.GetStatusButton);
    public canGetConstructionDiary$ = this.hasPermissionOrEntityPermission$(Permissions.GetBautagebuchButton);
    public canSeeHourList$ = this.hasPermissionOrEntityPermission$(Permissions.GetStundenlisteButton);
    public canUseQuickAddButton$ = this.hasPermissionOrEntityPermission$(Permissions.CreateEvents);
    public canCreateInterruptionEvent$ = this.hasPermissionOrEntityPermission$(Permissions.CreateTicket);



    public CurrentUser$ = this.store.select(getUser);

   // public Customers$ = this.store.select(getNotDeletedCustomers);
    public NetworkPartners$ = this.store.select(getPartners);
    public VersicherungsData$ = combineLatest([this.Commission$]).pipe(
        map(
            ([commission]): IDetailListTemplateData => ({
                HeaderIcon: 'university' as IconProp,
                Headline: 'Versicherungsdaten',
                Properties: [
                    {
                        key: 'Name',
                        value: commission.VersicherungsName,
                        formControl: this.CommissionForm.controls.VersicherungsName,
                    },
                    {
                        key: 'Zusatz',
                        value: commission.VersicherungsZusatzName,
                        formControl: this.CommissionForm.controls.VersicherungsZusatzName,
                    },
                    {
                        key: 'Arbeitsgebiet',
                        value: commission.VersicherungsArbeitsgebiet,
                        formControl: this.CommissionForm.controls.VersicherungsArbeitsgebiet,
                    },
                    {
                        key: 'Freitext',
                        value: commission.VersicherungsDescription,
                        formControl: this.CommissionForm.controls.VersicherungsDescription,
                    },
                    {
                        key: 'Telefonnummer',
                        value: commission.VersicherungsPhoneNumber,
                        formControl: this.CommissionForm.controls.VersicherungsPhoneNumber,
                    },
                    {
                        key: 'Mobil',
                        value: commission.VersicherungsMobileNumber,
                        formControl: this.CommissionForm.controls.VersicherungsMobileNumber,
                    },
                    {
                        key: 'Straße',
                        value: commission.VersicherungsStreet,
                        formControl: this.CommissionForm.controls.VersicherungsStreet,
                    },
                    {
                        key: 'PLZ',
                        value: commission.VersicherungsPostalCode,
                        formControl: this.CommissionForm.controls.VersicherungsPostalCode,
                    },
                    {
                        key: 'Stadt',
                        value: commission.VersicherungsCity,
                        formControl: this.CommissionForm.controls.VersicherungsCity,
                    },
                    {
                        key: 'Leistungszeitraum',
                        value: commission.ServicePeriod,
                        formControl: this.CommissionForm.controls.ServicePeriod,
                    },
                    {
                        key: 'Leistungsdatum',
                        value: commission.ServiceDate,
                        formControl: this.CommissionForm.controls.ServiceDate,
                    },
                    {
                        key: 'Wartungspauschale',
                        value: commission.MaintenanceFee,
                        formControl: this.CommissionForm.controls.MaintenanceFee,
                    },
                    {
                        key: 'Angebotsabgabe',
                        value: commission.OfferSubmissionDate,
                        formControl: this.CommissionForm.controls.OfferSubmissionDate,
                    },
                    {
                        key: 'Verhandlung am',
                        value: commission.NegotiationAt,
                        formControl: this.CommissionForm.controls.NegotiationAt,
                    },
                ],
            }),
        ),
    );
    private onInit$ = new BehaviorSubject(false);
    public IsBauAuftrag$ = combineLatest([merge(this.Commission$.pipe(map((commission) => ({ Id: commission.CommissionTypeId }))), this.CommissionForm.controls.CommissionTypeId.valueChanges), this.store.select(getCommissionTypes)]).pipe(
        map(([commissionType, commissionTypes]) => commissionType?.Id && commissionType.Id === commissionTypes.find((cT) => cT?.Name === CommissionTypeNameEnum.Bauprojekt)?.Id),
        distinctUntilChanged(),
    );
    private availableStatusBackoffice$ = this.CommissionType$.pipe(
        switchMap((commissionType) => {
            if (commissionType?.StatusBackofficeIds) {
                return getFetched$(this.store, getStatusFromBackofficeFetched, getStatusFromBackofficeDictionary).pipe(map((sbo) => commissionType.StatusBackofficeIds.map((id) => sbo[id])));
            }
            return of(null);
        }),
        shareReplay({ bufferSize: 1, refCount: true }),
    );
    statusBackofficeSteps$: Observable<{ active: number; steps: PseudoStepperComponent['steps'] }> = combineLatest([
        this.availableStatusBackoffice$,
        this.Commission$.pipe(
            map((c) => c.StatusBackofficeId),
            distinctUntilChanged(),
        ),
    ]).pipe(
        map(([statuses, id]) => {
            if (statuses) {
                const activeIndex = statuses.findIndex((s) => s.Id === id);
                return {
                    active: activeIndex,
                    steps: statuses.map((s, i) => ({ label: i + 1 + '. ' + s.Name, state: i < activeIndex ? 'done' : i > activeIndex ? 'number' : 'edit', disabled: true })),
                };
            }
            return null;
        }),
    );
    public CommissionSubData = combineLatest([
        this.Commission$,
        this.store.select(getStatusFromBackoffice),
        this.availableStatusBackoffice$,
        this.store.select(getStatusFromSV),
        this.IsBauAuftrag$,
        this.Partner$,
        this.cls.getLabels$('Commission'),
        this.cls.getMultiple$('CustomerSupplier'),
        this.cls.labels$,
        this.CommissionEntityRoles$
    ,
    ]).pipe(
        map(([commission, allBackofficeStatus, availableBackofficeStatus, statusSV, isBauAuftrag, partner, commissionLabels, customersLabel, customLabels, entityRoles]): IDetailListTemplateData[] => {
            // 1#####
            setCommissionDetailListTemplateEntries(
                commission,
                this.DetailListTemplateEntrys,
                ['AbgabeterminAG', 'AbgabeterminQM', 'LetzteFrist', 'NachlassZulage', 'VorarbeiterBonus', 'CostCenter'],
                this.CommissionForm,
                entityRoles,
                {},
                commissionLabels.Nominativ.singular.value,
                commissionLabels.wordBinding,
                commissionLabels.wordBinding + 'art',
                commissionLabels.wordBinding + 'nr.',
                customersLabel,
                customLabels,
            );
            const Properties = [
                this.DetailListTemplateEntrys.AbgabeterminAG,
                this.DetailListTemplateEntrys.AbgabeterminQM,
                {
                    value: commission.CreatedAt,
                    key: 'Erstellt am',
                    options: { type: CustomPropertyType.Datum },
                },
                this.DetailListTemplateEntrys.LetzteFrist,
                {
                    value: commission?.StatusBackofficeId !== null ? allBackofficeStatus?.find((bs) => bs.Id === commission?.StatusBackofficeId)?.Name : null,
                    key: 'Status Backoffice',
                    formControl: this.CommissionForm.controls.StatusBackofficeId,
                    options: {
                        specialInput: {
                            selectSearch: (availableBackofficeStatus || allBackofficeStatus).map((b) => ({
                                optionValue: b.Id,
                                optionLabel: b.Name,
                            })),
                        },
                    },
                },
                this.DetailListTemplateEntrys.CostCenter,
                {
                    value: commission?.Kostenstellenart ? KostenstellenartNames.get(commission.Kostenstellenart) : null,
                    key: 'Kostenstellenart',
                    formControl: this.CommissionForm.controls.Kostenstellenart,
                    options: {
                        specialInput: {
                            select: Object.values(KostenstellenartEnum).map((val) => ({
                                optionValue: val,
                                optionLabel: KostenstellenartNames.get(val),
                            })),
                        },
                    },
                },
            ];
            if (isBauAuftrag) {
                Properties.push(this.DetailListTemplateEntrys.VorarbeiterBonus, this.DetailListTemplateEntrys.NachlassZulage);
            }
            if (partner.PartnerSpecificationTypeId === PartnerSpecificationType.Appraiser) {
                Properties.push(
                    {
                        value: commission?.StatusfromSVId !== null ? statusSV?.find((ssv) => ssv.Id === commission?.StatusfromSVId).Name : null,
                        key: 'Status SV',
                        formControl: this.CommissionForm.get('StatusfromSVId'),
                        options: {
                            specialInput: {
                                selectSearch: statusSV?.map((c) => ({
                                    optionValue: c.Id,
                                    optionLabel: c.Name,
                                })),
                            },
                        },
                    },
                    {
                        value: commission.Versicherungsbedingung,
                        key: 'Versicherungsbedingung',
                        formControl: this.CommissionForm.get('Versicherungsbedingung'),
                    },
                );
            }
            const ret: IDetailListTemplateData[] = [
                {
                    HeaderIcon: CommissionMeta.Icon,
                    Headline: commissionLabels.wordBinding + 'daten',
                    Properties: Properties.filter(isNotNullOrUndefined),
                },
            ];
            if (partner.Id === window['env']['luksch_partner_id'] || partner.Id === window['env']['luksch_partner_id2'] ) {
                const lukschInvoiceData: IDetailListTemplateData = {
                    HeaderIcon: InvoiceEditorMeta.Icon,
                    Headline: 'Rechnungsdaten',
                    Properties: [
                        {
                            value: isNotNullOrUndefined(commission.RetentionPercentage) ? commission.RetentionPercentage / 100 : null,
                            key: 'Deckungsrücklass (' + LedgerImportDocumentTypeNames.get(LedgerImportDocumentTypes.PartialInvoice) + ')',
                            formControl: this.CommissionForm.controls.RetentionPercentage,
                            options: {
                                specialInput: {
                                    number: true,
                                },
                                suffix: '%',
                                type: CustomPropertyType.Percentage,
                            },
                        },
                        {
                            value: isNotNullOrUndefined(commission.PartialInvoiceDuePeriod) ? commission.PartialInvoiceDuePeriod : null,
                            key: 'Netto Zahlungsziel (' + LedgerImportDocumentTypeNames.get(LedgerImportDocumentTypes.PartialInvoice) + ')',
                            formControl: this.CommissionForm.controls.PartialInvoiceDuePeriod,
                            options: {
                                specialInput: {
                                    number: true,
                                },
                            },
                        },
                        {
                            value: isNotNullOrUndefined(commission.PartialInvoiceDiscountPeriod) ? commission.PartialInvoiceDiscountPeriod : null,
                            key: 'Skontofrist (' + LedgerImportDocumentTypeNames.get(LedgerImportDocumentTypes.PartialInvoice) + ')',
                            formControl: this.CommissionForm.controls.PartialInvoiceDiscountPeriod,
                            options: {
                                specialInput: {
                                    number: true,
                                },
                            },
                        },
                        {
                            value: isNotNullOrUndefined(commission.PartialInvoiceReviewPeriod) ? commission.PartialInvoiceReviewPeriod : null,
                            key: 'Prüffrist (' + LedgerImportDocumentTypeNames.get(LedgerImportDocumentTypes.PartialInvoice) + ')',
                            formControl: this.CommissionForm.controls.PartialInvoiceReviewPeriod,
                            options: {
                                specialInput: {
                                    number: true,
                                },
                            },
                        },
                        {
                            value: isNotNullOrUndefined(commission.PartialInvoiceDiscountPercentage) ? commission.PartialInvoiceDiscountPercentage / 100 : null,
                            key: 'Skonto (' + LedgerImportDocumentTypeNames.get(LedgerImportDocumentTypes.PartialInvoice) + ')',
                            formControl: this.CommissionForm.controls.PartialInvoiceDiscountPercentage,
                            options: {
                                specialInput: {
                                    number: true,
                                },
                                suffix: '%',
                                type: CustomPropertyType.Percentage,
                            },
                        },

                        {
                            value: isNotNullOrUndefined(commission.WarrantyRetentionPercentage) ? commission.WarrantyRetentionPercentage / 100 : null,
                            key: 'Haftrücklass (' + LedgerImportDocumentTypeNames.get(LedgerImportDocumentTypes.ClosingInvoice) + ')',
                            formControl: this.CommissionForm.controls.WarrantyRetentionPercentage,
                            options: {
                                specialInput: {
                                    number: true,
                                },
                                suffix: '%',
                                type: CustomPropertyType.Percentage,
                            },
                        },
                        {
                            value: isNotNullOrUndefined(commission.ClosingInvoiceDuePeriod) ? commission.ClosingInvoiceDuePeriod : null,
                            key: 'Netto Zahlungsziel (' + LedgerImportDocumentTypeNames.get(LedgerImportDocumentTypes.ClosingInvoice) + ')',
                            formControl: this.CommissionForm.controls.ClosingInvoiceDuePeriod,
                            options: {
                                specialInput: {
                                    number: true,
                                },
                            },
                        },
                        {
                            value: isNotNullOrUndefined(commission.ClosingInvoiceDiscountPeriod) ? commission.ClosingInvoiceDiscountPeriod : null,
                            key: 'Skontofrist (' + LedgerImportDocumentTypeNames.get(LedgerImportDocumentTypes.ClosingInvoice) + ')',
                            formControl: this.CommissionForm.controls.ClosingInvoiceDiscountPeriod,
                            options: {
                                specialInput: {
                                    number: true,
                                },
                            },
                        },
                        {
                            value: isNotNullOrUndefined(commission.ClosingInvoiceReviewPeriod) ? commission.ClosingInvoiceReviewPeriod : null,
                            key: 'Prüffrist (' + LedgerImportDocumentTypeNames.get(LedgerImportDocumentTypes.ClosingInvoice) + ')',
                            formControl: this.CommissionForm.controls.ClosingInvoiceReviewPeriod,
                            options: {
                                specialInput: {
                                    number: true,
                                },
                            },
                        },
                        {
                            value: isNotNullOrUndefined(commission.ClosingInvoiceDiscountPercentage) ? commission.ClosingInvoiceDiscountPercentage / 100 : null,
                            key: 'Skonto (' + LedgerImportDocumentTypeNames.get(LedgerImportDocumentTypes.ClosingInvoice) + ')',
                            formControl: this.CommissionForm.controls.ClosingInvoiceDiscountPercentage,
                            options: {
                                specialInput: {
                                    number: true,
                                },
                                suffix: '%',
                                type: CustomPropertyType.Percentage,
                            },
                        },
                    ],
                };
                ret.push(lukschInvoiceData);
            }
            return ret;
        }),
    );
    public DamageFlowData$ = new Observable<IDetailListTemplateData>();
    public Title: string;
    public DamageFlowLocationForm = this.fb.group({
        Street: new FormControl<string | null>(null),
        PostalCode: new FormControl<string | null>(null),
        City: new FormControl<string | null>(null),
        Country: new FormControl<string | null>(null),
    });
    public CommissionLocationForm = new FormControl<Address>({
        Street: '',
        PostalCode: '',
        City: '',
        Country: '',
    });
    // this.fb.group({
    //     Street: new FormControl<string | null>(null),
    //     PostalCode: new FormControl<string | null>(null),
    //     City: new FormControl<string | null>(null),
    //     Country: new FormControl<string | null>(null),
    // });
    public DamageFlowForm = this.fb.group({
        AbgabeterminBerichtReal: new FormControl<Date | null>(null),
        DeadlineVerlaengerung: new FormControl<string | null>(null),
        Description: new FormControl<string | null>(null),
        DamageFlowTypeId: new FormControl<SelectSearchData | null>(null),
        ErsterBerichtEingegangen: new FormControl<boolean | null>(null),
        ErsterOrtstermin: new FormControl<Date | null>(null),
        KontaktMitVersicherungsnehmer: new FormControl<Date | null>(null),
        ObjektiveSchadensumme: new FormControl<string | null>(null),
        QMDurchgefuehrtAm: new FormControl<Date | null>(null),
        QMStatusId: new FormControl<SelectSearchData | null>(null),
        ReportCount: new FormControl<number | null>(null),
        SchadenannahmeDurchSV: new FormControl<Date | null>(null),
        WeiterleitungAnVu: new FormControl<Date | null>(null),
    });
    public PreviewOpen = false;
    public PreviewedFileId$ = new BehaviorSubject<number | null>(null);
    public ImageIds: number[];
    public DocumentEditorPageMeta = DocumentEditorPageMeta;
    public NewBookingPositionClick$ = new Subject<void>();
    public BookingPositions$ = combineLatest([this.route.paramMap]).pipe(
        map(([paramMap]) => +paramMap.get('commissionId')),
        switchMap((commissionId) =>
            this.arlDataService.getARLsForCommission(commissionId).pipe(
                map((BookingPositions) => {
                    return BookingPositions.filter((b) => !b.ParentId && !b.LedgerImportId);
                }),
                map((b) => {
                    return b;
                }),
            ),
        ),
    );
    public HiddenBookingPositions$ = combineLatest([this.route.paramMap]).pipe(
        map(([paramMap]) => +paramMap.get('commissionId')),
        switchMap((commissionId) =>
            from(this.arlDataService.getARLsForCommission(commissionId)).pipe(
                map((bookingPositions) => bookingPositions.filter((b) => b.DocumentType !== 'offer')),
                switchMap((bookingPositions) =>
                    combineLatest([
                        this.store.select(getQuantityTypes).pipe(filter(isNotNullOrUndefined)),
                        this.ledgerImportDataService.getLedgerImportIds$(
                            bookingPositions.map((b) => b.LedgerImportId)
                        ),
                    ]).pipe(
                        map(([quantityTypes, ledgerImports]) =>
                            bookingPositions.map((b) => ({
                                ...b,
                                Unit: quantityTypes.find((q) => q.Id === b.QuantityTypeId)?.Name,
                                CompleteCost: this.currencyPipe.transform(NettoCost(b.Quantity, b.BaseCost), b.CurrencyCode),
                                Quantity: b.Quantity && this.decimalPipe.transform(b.Quantity),
                                InvoiceNumber: ledgerImports.find((l) => l.Id === b.LedgerImportId)?.ConsolidatedInvoiceId || '',
                            }))
                        )
                    )
                )
            ),
        ),
    );

    public LedgerImports$ = combineLatest([this.route.paramMap]).pipe(
        map(([paramMap]) => +paramMap.get('commissionId')),
        switchMap((commissionId) =>
            from(this.ledgerImportDataService.getLedgerImportsFromCommissions$([commissionId])).pipe(
                map((LedgerImports) => LedgerImports.filter((b) => !b.IsTemplate)),
            ),
        ),
        shareReplay({ refCount: true, bufferSize: 1 }),
    );

    private getLedgerImportsByDocTypes$ = (...documentTypes: LedgerImportDocumentTypes[]) =>
        this.LedgerImports$.pipe(
            map((LedgerImports) =>
                LedgerImports.filter((li) => documentTypes.includes(li.DocumentType))
                    .map((b) => {
                        return {
                            ...b,
                            Sum: this.currencyPipe.transform(b.ConsolidatedNettoAmount, b.ConsolidatedCurrencyCode),
                            DueDate: this.datePipe.transform(b.DueDate),
                            suffixButton: b.DocumentId
                                ? {
                                      icon: DMSPageMeta.Icon,
                                      tooltip: 'Zum Dokument',
                                      hide: (args: LedgerImportEntity) => {
                                          return !args.DocumentId;
                                      },
                                      onClick: (args: LedgerImportEntity) => {
                                          if (args.DocumentCanBeDownloaded) {
                                              this.PreviewedFileId$.next(args.DocumentId);
                                              this.PreviewOpen = true;
                                          } else {
                                              this.toastrService.warning('Dieser Dokument kann noch nicht heruntergeladen werden.');
                                          }
                                      },
                                  }
                                : null,
                            cssClass: b.GetBackgroundColorClass(),
                        };
                    })
                    .sort((a, b) => (a.CreatedAt < b.CreatedAt ? 1 : -1)),
            ),
        );

    private bookmarks$: Observable<Array<BookmarkEntity>>;
    private persons$: Observable<Array<PersonEntity>>;
    public Customer$ = this.Commission$.pipe(
        switchMap(commission =>
            commission?.CustomerId ? this.customerDataService.GetSingleCustomer$(commission.CustomerId) : of(null)
        )
    );
    public IsVersicherung$ = combineLatest([
        merge(
            this.onInit$.pipe(
                withLatestFrom(this.Commission$),
                map(([, commission]) => ({ Id: commission.CustomerId })),
            ),
            this.CommissionForm.controls.Customer.valueChanges,
        ),
        this.Customer$,
        this.store.select(getCustomerSpecificationTypes),
    ]).pipe(
        map(([customer, customerEntitiy, customerSpecificationTypes]) =>
            customerSpecificationTypes
                .find((cst) => cst.Id === customerEntitiy?.CustomerSpecificationTypeId)
                ?.Name.toLowerCase()
                .includes('versicherung'),
        ),
        distinctUntilChanged(),
        shareReplay({ refCount: true, bufferSize: 1 }),
    );
    public IsConstructionPartner$ = new BehaviorSubject<boolean>(false);
    public customerSearch: CustomerSearchState = this.customerDataService.createSearchState();

    public CommissionMainData = combineLatest([
        this.Commission$,
        this.store.select(getCommissionTypes),
        //this.Customers$,
        this.customerLabel$,
        this.customerOnlyLabel$,
        merge(
            this.onInit$.pipe(
                withLatestFrom(this.Commission$),
                map(([, commission]) => ({ Id: commission.CommissionTypeId })),
            ),
            this.CommissionForm.controls.CommissionTypeId.valueChanges,
        ),
        combineLatest([
            this.store.select(getPersons),
            this.IsVersicherung$,
            this.store.select(getOffices),
            this.store.select(getOwnPartnerOffices),
            this.store.select(getPerson2Entities).pipe(
                filter(isNotNullOrUndefined),
                map((pes) => pes.filter((pe) => pe.EntityType === Person2EntityEntityTypeEnum.Customer)),
            ),
            this.store.select(getPartner),
            this.store.select(getCommissions)
        ]),
        this.cls.getSingle$('Commission'),
        this.cls.getLabels$('Commission'),
        this.cls.getMultiple$('Customer'),
        this.CommissionEntityRoles$,
        getCommissionLocationOptions(this.store),
        getFetched$(this.store, getTravelZonesFetched, getTravelZoneDictionary).pipe(first()),
        this.cls.labels$,
        this.store.select(getDepartmentDictionary),
        this.store.select(getPartnerOffices),
        this.store.select(getUserDictionary),
        this.store.select(getEmployees),
        this.store.select(getStatusFromBackoffice),
        this.store.select(getJobSpecification)
    ]).pipe(
        map(
            ([
                 commission,
                 commissionTypes,
                // customers,
                 CustomerName,
                 CustomerNameWithoutSupplier,
                 currentCommissionType,
                 [persons, isVersicherung, offices, ownParterOffices, personEntities, partner, commissions],
                 commissionLabel,
                 commissionLabels,
                 customersLabel,
                 entityRoles,
                 commissionLocationOptions,
                 travelZones,
                 customLabels,
                 departments,
                partnerOffices,
                users,
                employees,
                statusBackoffice,
                jobSpecs,
            ]): IDetailListTemplateData => {
                const commissionTypeGericht = commissionTypes.find((c) => c.Name === CommissionTypeNameEnum.Gericht);


                const commissionType = commission?.CommissionTypeId !== null ? commissionTypes?.find((c) => c.Id === commission?.CommissionTypeId) : null;
                const currentCommissionTypeEntity = currentCommissionType?.Id ? commissionTypes?.find((c) => c.Id === currentCommissionType.Id) : null;
                const person = commission?.PersonId !== null && isVersicherung ? persons?.find((cP) => cP.Id === commission?.PersonId) : null;
                const detailKeys: Array<keyof ICommissionDetailListTemplateEntrys> = [
                'Customer',
                'CommissionType',
                'Description',
                'CommissonNumber',
                'CommissonNumberAuto',
                'InterneNummer',
                'InterneNummerAuto',
                'Location',
                'Auftragseingang',
                'StartDate',
                'PlanedStartDate',
                'EndDate',
                'PlanedEndDate',
                'Schadensdatum',
                'Versicherungssumme',
                'Schadennummer',
                'Versicherungsnummer',
                'AutomaticAccountsReceivableLedger',
                'AutomaticAccountsReceivableLedgerByClockIns',
                'ProjectInfo',
                'OrderNoCustomer',
                'CompleteBusinessVolume',
                'CostsCompleteBusinessVolume',
                'PlanedWorkingHours',
                'HandoverDate',
                'TravelZoneId',
                'MaintenanceSurcharge',
                'OfferSubmissionDate',
                'NegotiationAt',
                'Person',
                'DepartmentId',
                'ParentCommission',
                'ProjectAdmin',
                'StatusBackofficeId',
                'ProjectManager'
            ];
            if (this.showServicePeriod) {
                detailKeys.push('ServicePeriod', 'ServiceDate');
            }
                detailKeys.push('MaintenanceFee');
            // const customer = person?.CustomerId ? customers.find(o => o.Id === person.CustomerId) : null;
            // ####2
                const customerLabel = this.hideSuppliers ? CustomerNameWithoutSupplier : CustomerName
            setCommissionDetailListTemplateEntries(
                commission,
                this.DetailListTemplateEntrys,
                detailKeys,
                this.CommissionForm,
                entityRoles,
                {
                   CustomerName: customerLabel,
                  //  customers,
                  //  offices,
                    commissionType,
                    commissionTypes,
                    partner,
                    currentCommissionTypeEntity,
                    currentCommissionType,
                    // SearchLocationForm: this.SearchLocationForm,
                    CommissionLocationForm: this.CommissionLocationForm,
                    commissionLocationOptions,
                    travelZone: commission.TravelZoneId ? travelZones[commission.TravelZoneId] : null,
                    persons,
                    departmentSelectTemplate: this.departmentSelectTemplate,
                    departments: departments,
                    commissions,
                    partnerOffices,
                    users,
                    employees,
                    statusBackoffice,
                    jobSpecs,
                    customerSearch: {
                    customerOptions$: this.customerSearch.customerOptions$,
                    customerOptionsLoading$: this.customerSearch.loading$,
                    searchCustomers: (search) => this.customerSearch.SearchCustomers(search, 'unbenannter' + customersLabel),
                    customerPageIndex$: this.customerSearch.customerPaging.pageIndex$,
                    customerPageCount$: this.customerSearch.customerPaging.pageCount$,
                    customerPageChange: (event) =>
                        this.customerSearch.customerPageChange(event),
                        }
                },
                commissionLabel,
                commissionLabels.wordBinding,
                commissionLabels.wordBinding + 'art',
                commissionLabels.wordBinding + 'nr.',
                customersLabel,
                customLabels,
            );
            const Properties: IDetailListTemplateDataProperty[] = [this.DetailListTemplateEntrys.Customer, this.DetailListTemplateEntrys.CommissionType];
            if (ownParterOffices?.length > 1) {
                Properties.push({
                    value: commission?.PartnerOfficeId !== null ? ownParterOffices?.find((po) => po.Id === commission?.PartnerOfficeId)?.Name : null,
                    key: 'Unternehmen',
                    formControl: this.CommissionForm.controls.PartnerOffice,
                    options: {
                        specialInput: {
                            selectSearch: ownParterOffices?.map((c) => ({
                                optionValue: c.Id,
                                optionLabel: c.Name,
                            })),
                        },
                    },
                });
            }
            Properties.push(
                this.DetailListTemplateEntrys.DepartmentId,
                this.DetailListTemplateEntrys.InterneNummer,
                this.DetailListTemplateEntrys.InterneNummerAuto,
                this.DetailListTemplateEntrys.CommissonNumber,
                this.DetailListTemplateEntrys.CommissonNumberAuto,
                this.DetailListTemplateEntrys.Description,
                this.DetailListTemplateEntrys.OrderNoCustomer,
                this.DetailListTemplateEntrys.ProjectInfo,
                // this.DetailListTemplateEntrys.CustomerLocation,
                this.DetailListTemplateEntrys.Location,
                this.DetailListTemplateEntrys.Auftragseingang,
                this.DetailListTemplateEntrys.HandoverDate,
                this.DetailListTemplateEntrys.StartDate,
                this.DetailListTemplateEntrys.PlanedStartDate,
                this.DetailListTemplateEntrys.EndDate,
                this.DetailListTemplateEntrys.PlanedEndDate,
                this.DetailListTemplateEntrys.Schadensdatum,
                this.DetailListTemplateEntrys.Versicherungssumme,
                partner.PartnerSpecificationTypeId === PartnerSpecificationType.Appraiser ? this.DetailListTemplateEntrys.Schadennummer : null,
                partner.PartnerSpecificationTypeId === PartnerSpecificationType.Appraiser ? this.DetailListTemplateEntrys.Versicherungsnummer : null,
                {
                    value: commission.FreeTextField2,
                    key: 'Freitext 2',
                    formControl: this.CommissionForm.controls.FreeTextField2,
                    options: {
                        specialInput: {
                            textArea: {
                                Fill: false,
                            },
                        },
                    },
                },
                {
                    value: commission.FreeTextField3,
                    key: 'Freitext 3',
                    formControl: this.CommissionForm.controls.FreeTextField3,
                    options: {
                        specialInput: {
                            textArea: {
                                Fill: false,
                            },
                        },
                    },
                },
                {
                    hideFormControl: currentCommissionType.Id !== commissionTypeGericht.Id,
                    value: currentCommissionType.Id === commissionTypeGericht.Id ? commission.Aktenzeichen : null,
                    key: 'Aktenzeichen.',
                    formControl: this.CommissionForm.controls.Aktenzeichen,
                    options: {
                        showHint: 'Um einer Verwechslungen vorzubeugen, werden bei der automatisierten Zuordnung nur Nummern mit fünf oder mehr Zeichen berücksichtigt.',
                    },
                },
                {
                    hideFormControl: !isVersicherung,
                    value: person?.DisplayName,
                    key: 'Sachbearbeiter',
                    formControl: this.CommissionForm.controls.Person,
                    options: {
                        specialInput: {
                            selectSearch: persons
                                .filter((p) => personEntities.find((pe) => pe.PersonId === p.Id && pe.EntityId === this.CommissionForm.controls.Customer.value?.Id) !== null)
                                // ?.filter(cP => cP.CustomerId === this.CommissionForm.controls.Customer.value?.Id)
                                .map((c) => ({
                                    optionValue: c.Id,
                                    optionLabel: isNotNullOrUndefined(c.DisplayName)
                                        ? c.DisplayName + (isNotNullOrUndefined(c.Email) ? ' ' + c.Email : '') + (isNotNullOrUndefined(c.Description) ? ' ' + c.Description : '')
                                        : 'unbennanter Sachbearbeiter',
                                })),
                        },
                    },
                },
                {
                    value: commission.UpdatedAt,
                    key: 'Aktualisiert am',
                    options: { type: CustomPropertyType.Datum },
                },
                this.DetailListTemplateEntrys.AutomaticAccountsReceivableLedger,
                this.DetailListTemplateEntrys.AutomaticAccountsReceivableLedgerByClockIns,
                this.DetailListTemplateEntrys.CompleteBusinessVolume,
                this.DetailListTemplateEntrys.CostsCompleteBusinessVolume,
                this.DetailListTemplateEntrys.PlanedWorkingHours,
                this.DetailListTemplateEntrys.TravelZoneId,
                this.DetailListTemplateEntrys.ServicePeriod,
                this.DetailListTemplateEntrys.ServiceDate,
                this.DetailListTemplateEntrys.MaintenanceFee,
                this.DetailListTemplateEntrys.MaintenanceSurcharge,
                {
                    key: 'Farbmarkierung auswählen',
                    formControl: this.CommissionForm.controls.Color,
                    options: {
                        specialInput: {
                            colorPicker: true
                        }
                    }
                },
                this.DetailListTemplateEntrys.OfferSubmissionDate,
                this.DetailListTemplateEntrys.NegotiationAt
            );
            const headline = commissionType?.Name === CommissionTypeNameEnum.Projekt ? commission.Auftragsnummer || '' : commission.InterneNummer ? commission.InterneNummer : ''
                return {
                    HeaderIcon: headline ? 'hashtag' as IconProp : undefined,
                    Headline: headline,
                    Properties: Properties.filter(isNotNullOrUndefined),
                };
            },
        ),
        shareReplay({ refCount: true, bufferSize: 1 }),
    );

    private subscriptions: Subscription[] = [];

    get AreFormsInvalid() {
        if(this.skipSaveChecksExceptCommssionType){
            const invalid = this.CommissionForm.controls.CommissionTypeId.status === 'INVALID' || this.CommissionForm.controls.Description.invalid;
            return invalid;
        }else {
            const invalid = this.CommissionForm.status === 'INVALID' || this.DamageFlowForm.status === 'INVALID';
            return invalid;
        }
    }

    GetRouteForLedgerImport = (ledgerImport: LedgerImportEntity) => ['/', ReportsPageMeta.Path, AllReportsMeta.Path, ledgerImport.Id];
    GetRouteForDiary = (diary: GeneratedDocumentsEntity) => ['/', GeneratedDocumentsPageMeta.Path, AllReportsMeta.Path, DocumentEditorMeta.Path, diary.Id];
    GetRouteForEvent = (event: EventEntity) => ['/', HistoryMeta.Path, this.AllEventsMetaPath, event.Id];
    GetRouteForGenDoc = (doc: { Id: number }) => ['/', GeneratedDocumentsPageMeta.Path, AllGeneratedDocumentsMeta.Path, DocumentEditorMeta.Path, doc.Id];
    // public logCache = {}

    GetTemplateByType(type: commissionViewStyleTypes): TemplateRef<any> {
        // todo jedes template wird x33 abgerufen
        // this.logCache[type] = this.logCache[type] ? this.logCache[type] +1 : 1;

        switch (type) {
            case 'commissionOverviewTemplate':
                return this.commissionOverviewTemplate;
            case 'detailListTemplateCommission':
                return this.detailListTemplateCommissionTemplate;
            case 'group':
                return this.groupTemplate;
            case 'shiftplan':
                return this.shiftPlanTemplate;
            case 'resourceplan':
                return this.resourcePlanTemplate;
            case 'taskBoard':
                return this.taskTemplate;
            case 'fileExplorer':
                return this.fileExplorerTemplate;
            case 'additionalFoldersFileExplorer':
                return this.additionalFoldersFileExplorerTemplate;
            case 'eventList':
                return this.eventListTemplate;
            case 'personList':
                return this.personListTemplate;
            case 'bookingPositionList':
                return this.bookingPositionListTemplate;
            // case 'invoiceList':
            //     return this.invoiceListTemplate;
            // case 'offerList':
            //     return this.offerListTemplate;
            case 'ledgerImportListTemplate':
                return this.ledgerImportListTemplate;
            case 'hiddenBookingPositionList':
                return this.hiddenBookingPositionListTemplate;
            case 'judgeList':
                return this.judgeListTemplate;
            case 'reportsListDiary':
                return this.reportsListDiary;
            case 'reportsListZusatz':
                return this.reportsListZusatz;
            case 'reportsListBedenken':
                return this.reportsListBedenken;
            case 'reportsListErschwernis':
                return this.reportsListErschwernis;
            case 'reportsListMangel':
                return this.reportsListMangel;
            case 'reportsListOther':
                return this.reportsListOther;
            case 'klaegerList':
                return this.klaegerListTemplate;
            case 'beklagteList':
                return this.beklagteListTemplate;
            case 'selectedPartnerList':
                return this.selectedPartnerListTemplate;
            case 'selectedUsersList':
                return this.selectedUsersListTemplate;
            case 'tabGroup':
                return this.tabGroupTemplate;
            case 'nachnahmenListTemplate':
                return this.nachnahmenListTemplate;
            case 'auffaelligkeitListTemplate':
                return this.auffaelligkeitListTemplate;
            case 'reportsListAuffaelligkeit':
                return this.reportsListAuffaelligkeit;
            case 'dokumentationListTemplate':
                return this.dokumentationListTemplate;
            case 'regiearbeitenListTemplate':
                return this.regiearbeitenListTemplate;
            case 'reportsListDokumentation':
                return this.reportsListDokumentation;
            case 'reportsListRegiearbeiten':
                return this.reportsListRegiearbeiten;
            case 'mangelListTemplate':
                return this.erschwernisListTemplate;
            case 'commentsTemplate':
                return this.commentsTemplate;
            case 'commissionTitleTabGroupTemplate':
                return this.commissionTitleTabGroupTemplate;
            case 'entityHistoryTemplate':
                return this.entityHistoryTemplate;
            case 'resourceScheduleListeTemplate':
                return this.resourceScheduleListeTemplate;
            case 'resourceListTemplate':
                return this.resourceListTemplate;
            case 'materialListTemplate':
                return this.materialListTemplate;
            case 'groupListTemplate':
                return this.groupListTemplate;
            case 'bedenkenanzeigeListTemplate':
                return this.bedenkenanzeigeListTemplate;
            case 'mangelanzeigeListTemplate':
                return this.mangelanzeigeListTemplate;
            case 'childCommissionsTemplate':
                return this.childCommissionsTemplate;
            case 'reportsTabGroupTemplate':
                return this.reportsTabGroupTemplate;
            case 'CommissionBusinessVolumeList':
                return this.CommissionBusinessVolumeList;
            case 'blueprintTemplate':
                return this.blueprintTemplate;
            case 'processListTemplate':
                return this.processListTemplate;
            default:
                console.error('View nicht gefunden', type);
        }
    }
    // private setCommissionSeen(id: number) {
    //     this.changesService.setAllChangesFromEntitySeen(id, EntityType.Commission);
    // }
    ngOnDestroy(): void {
        // firstValueFrom(this.Commission$).then((commission) => {
        //     if (commission) {
        //         this.setCommissionSeen(commission.Id);
        //     }
        // });
        this.subscriptions.forEach((subscription) => subscription.unsubscribe());
        this.fileDialog?.close();

        this.Editing$.complete();
        this.Save$.complete();
        this.TaskBoardFilterValues$.complete();
        this.ShiftPlanActiveView$.complete();
        this.ResourcePlanActiveView$.complete();
        this.PreviewedFileId$.complete();
        this.SaveStatus$.complete();
        this.ProcessFilterValues$.complete();
        this.onInit$.complete();
        this.OpenShiftPlan$.complete();
        this.OpenResourcePlan$.complete();
        this.NewBookingPositionClick$.complete();
    }

    ngOnInit(): void {
        this.onInitTimestamp = new Date();
        this.onInit$.next(true);
        this.subscriptions.push(
            this.Commission$.subscribe((c) => this.statusDropdown.reset(c.StatusBackofficeId, { emitEvent: false })),
            this.OpenShiftPlan$.pipe(withLatestFrom(this.Commission$, this.ShiftPlanActiveView$)).subscribe(([, commission, activeView]) => {
                this.dialog
                    .open<ShiftPlanDialogComponent, ShiftPlanComponentDialogData>(ShiftPlanDialogComponent, {
                        ...ShiftPlanDialogComponent.DefaultConfig,
                        data: {
                            CommissionId: commission.Id,
                            View: activeView,
                            DefaultFilter: this.shiftplan?.FilterValues$.value,
                        },
                    })
                    .afterClosed()
                    .subscribe((viewStyle) => this.ShiftPlanActiveView$.next(viewStyle));
            }),
            this.OpenResourcePlan$.pipe(withLatestFrom(this.Commission$, this.ResourcePlanActiveView$)).subscribe(([, commission, activeView]) => {
                this.dialog
                    .open<ResourcePlanDialogComponent, ResourcePlanComponentDialogData>(ResourcePlanDialogComponent, {
                        ...ResourcePlanDialogComponent.DefaultConfig,
                        data: {
                            CommissionId: commission.Id,
                            View: activeView,
                            DefaultFilter: this.resourceplan?.FilterValues$.value,
                        },
                    })
                    .afterClosed()
                    .subscribe((viewStyle) => this.ResourcePlanActiveView$.next(viewStyle));
            }),
            this.bookmarks$.subscribe((value) => {
                this.BookmarkList = value;
            }),

            this.persons$.subscribe((value) => {
                this.PersonList = value;
            }),
            this.PreviewedFileId$.subscribe((id) => {
                if (id && id > -1) {
                    this.PreviewOpen = true;
                    this.fileDialog?.close();
                } else if (id === null) {
                    this.PreviewOpen = false;
                    if (+this.route.snapshot.queryParams?.documentId) {
                        this.router.navigate([], {
                            relativeTo: this.route,
                            queryParams: {
                                documentId: null,
                            },
                            queryParamsHandling: 'merge',
                            replaceUrl: true,
                        });
                    }
                }
            }),
        );

        this.StatusData = combineLatest([this.Commission$, this.availableStatusBackoffice$, this.store.select(getStatusFromBackoffice)]).pipe(
            map(([c, boS, allBos]) => {
                return {
                    Properties: [
                        {
                            key: 'Status',
                            value: '',
                            formControl: this.statusDropdown,
                            options: {
                                specialInput: {
                                    select: (boS || allBos).map((b) => ({
                                        optionLabel: b.Name,
                                        optionValue: b.Id,
                                    })),
                                },
                            },
                        },
                    ],
                };
            }),
        );
        this.DamageFlowData$ = combineLatest([this.store.select(getDamageFlows), this.Commission$, this.store.select(getQMStatus), this.store.select(getDamageFlowTypes)]).pipe(
            map(([damageFlows, commission, qMStatus, damageFlowTypes]) => {
                const damageFlow = damageFlows.find((d) => d.CommissionId === commission.Id);

                const address = damageFlow
                    ? {
                          Street: damageFlow.Street,
                          PostalCode: damageFlow.PostalCode,
                          City: damageFlow.City,
                          Country: damageFlow.Country,
                      }
                    : (null as Address);

                return damageFlow
                    ? {
                          HeaderIcon: 'house-damage' as IconProp,
                          Headline: 'Schadensdaten',
                          Properties: [
                              {
                                  key: 'Adresse',
                                  options: {
                                      type: CustomPropertyType.Location,
                                      specialInput: {
                                          location: {
                                              value: address,
                                              formGroup: this.DamageFlowLocationForm,
                                          },
                                      },
                                  },
                                  value: getAddressString(address),
                              },
                              {
                                  value: damageFlow.CreatedAt,
                                  key: 'Erstellt am',
                                  options: { type: CustomPropertyType.Datum },
                              },
                              {
                                  value: damageFlow.UpdatedAt,
                                  key: 'Aktualisiert am',
                                  options: { type: CustomPropertyType.Datum },
                              },
                              {
                                  value: damageFlow.AbgabeterminBerichtReal,
                                  key: 'AbgabeterminBerichtReal',
                                  formControl: this.DamageFlowForm.get('AbgabeterminBerichtReal'),
                                  options: {
                                      type: CustomPropertyType.Datum,
                                      specialInput: { date: true },
                                  },
                              },
                              {
                                  value: damageFlow?.DamageFlowTypeId !== null ? damageFlowTypes?.find((dtypes) => dtypes.Id === damageFlow?.DamageFlowTypeId).Name : null,
                                  key: 'Schadensart',
                                  formControl: this.DamageFlowForm.get('DamageFlowTypeId'),
                                  options: {
                                      specialInput: {
                                          selectSearch: damageFlowTypes?.map((q) => ({
                                              optionValue: q.Id,
                                              optionLabel: q.Name,
                                          })),
                                      },
                                  },
                              },
                              {
                                  value: damageFlow.Description,
                                  key: 'Freitext',
                                  formControl: this.DamageFlowForm.get('Description'),
                              },
                              {
                                  value: damageFlow.DeadlineVerlaengerung,
                                  key: 'Frist Verlängerung',
                                  formControl: this.DamageFlowForm.get('DeadlineVerlaengerung'),
                              },
                              {
                                  value: damageFlow.ErsterBerichtEingegangen,
                                  key: 'Erster Bericht eingegangen',
                                  formControl: this.DamageFlowForm.get('ErsterBerichtEingegangen'),
                                  options: {
                                      type: CustomPropertyType.Boolean,
                                      specialInput: { boolean: true },
                                  },
                              },
                              {
                                  value: damageFlow.ErsterOrtstermin,
                                  key: 'Erster Ortstermin',
                                  formControl: this.DamageFlowForm.get('ErsterOrtstermin'),
                                  options: {
                                      type: CustomPropertyType.Datum,
                                      specialInput: { date: true },
                                  },
                              },
                              {
                                  value: damageFlow.KontaktMitVersicherungsnehmer,
                                  key: 'Kontakt mit Versicherungsnehmer',
                                  formControl: this.DamageFlowForm.get('KontaktMitVersicherungsnehmer'),
                                  options: {
                                      type: CustomPropertyType.Datum,
                                      specialInput: { date: true },
                                  },
                              },
                              {
                                  value: damageFlow.ObjektiveSchadensumme,
                                  key: 'Objektive Schadensumme',
                                  formControl: this.DamageFlowForm.get('ObjektiveSchadensumme'),
                              },
                              {
                                  value: damageFlow.QMDurchgefuehrtAm,
                                  key: 'QM durchgefuehrt am',
                                  formControl: this.DamageFlowForm.get('QMDurchgefuehrtAm'),
                                  options: {
                                      type: CustomPropertyType.Datum,
                                      specialInput: { date: true },
                                  },
                              },
                              {
                                  value: damageFlow?.QMStatusId !== null ? qMStatus?.find((qm) => qm.Id === damageFlow?.QMStatusId).Name : null,
                                  key: 'QM Status',
                                  formControl: this.DamageFlowForm.get('QMStatusId'),
                                  options: {
                                      specialInput: {
                                          selectSearch: qMStatus?.map((q) => ({
                                              optionValue: q.Id,
                                              optionLabel: q.Name,
                                          })),
                                      },
                                  },
                              },
                              {
                                  value: damageFlow.ReportCount,
                                  key: 'Anzahl Berichte erstellt',
                                  formControl: this.DamageFlowForm.get('ReportCount'),
                              },
                              {
                                  value: damageFlow.SchadenannahmeDurchSV,
                                  key: 'Schadenannahme durch SV',
                                  formControl: this.DamageFlowForm.get('SchadenannahmeDurchSV'),
                                  options: {
                                      type: CustomPropertyType.Datum,
                                      specialInput: { date: true },
                                  },
                              },
                              {
                                  value: damageFlow.WeiterleitungAnVu,
                                  key: 'Weiterleitung an VU',
                                  formControl: this.DamageFlowForm.get('WeiterleitungAnVu'),
                                  options: {
                                      type: CustomPropertyType.Datum,
                                      specialInput: { date: true },
                                  },
                              },
                          ],
                      }
                    : null;
            }),
        );
        this.CommentFileUploadParams$ = this.Commission$.pipe(
            map(c => c?.Id),
            distinctUntilChanged(),
            map(
                (commissionId) =>
                    commissionId &&
                    new Map<keyof fileUploadParamsObj, string>([
                        ['hidden', 'true'],
                        ['auto_set_folder', 'true'],
                        ['sub_folder_type', getFolderTypeString(FolderTypes.image_root)],
                        ['commission_id', JSON.stringify([commissionId])],
                    ]),
            ),
        );
        this.subscriptions.push(
            this.Partner$.subscribe((p) => {
                const isKaplStepEnabled = p.Settings?.WizardSteps?.includes(CommissionWizardSteps.StammdatenKapl);
                if (isKaplStepEnabled) {
                    this.CommissionForm.controls?.Description?.addValidators(Validators.required);
                    this.CommissionForm.controls?.Customer?.addValidators(Validators.required);
                    this.DepartmentRequired.next(true);
                    this.CommissionLocationRequired.next(true);
                    this.skipSaveChecksExceptCommssionType = true;

                }
                if (p.PartnerSpecificationTypeId === PartnerSpecificationType.Construction) {
                    this.IsConstructionPartner$.next(true);
                } else {
                    this.IsConstructionPartner$.next(false);
                }
            }),
            this.bookmarks$.subscribe((value) => {
                this.BookmarkList = value;
                // this.isReadyToShow(); copied from timeline, prob. not necessary
            }),
            // Workaround um die forms am anfang ein mal zu füllen damit diese vom wizard verwendet werden können
            combineLatest([this.Commission$, this.store.select(getDamageFlows)])
                .pipe(
                    filter((v) => v.every(isNotNullOrUndefined)),
                    take(1),
                )
                .subscribe(([commission, damageFlows]) => {
                    if (commission.AdditionalData?.wizardPage) {
                        this.setFormControls(commission, damageFlows);
                    }
                }),
            this.NewBookingPositionClick$.pipe(
                withLatestFrom(this.Commission$),
                tap(([, commission]) => {
                    this.dialog.open<NewBookingOptionComponent, NewOptionDialogData>(NewBookingOptionComponent, {
                        ...NewBookingOptionComponent.DefaultConfig,
                        data: commission
                            ? {
                                  newOptionDefaultValues: {
                                      CommissionId: commission.Id,
                                  },
                                  accountsReceivableLedgerTemplateFilter: {
                                      CommissionTypeId: commission.CommissionTypeId,
                                  },
                                selectLedgerImportDefaultFilter: {[FilterTypes.AssignedCommission]: [{label: commission.chipLabel, id:commission.Id }]},
                              }
                            : null,
                    });
                }),
            ).subscribe(),
            this.Editing$.pipe(withLatestFrom(this.Commission$, this.store.select(getDamageFlows), this.ViewStyleConfig$)).subscribe(([editing, commission, damageFlows, vsc]) => {
                if (editing) {
                    console.log('setFormControls');
                    this.setFormControls(commission, damageFlows);
                    if (this.commissionTitleTabGroupTemplateTabGroup) {
                        let index = null;
                        this.commissionTitleTabGroupTemplateTabGroup._tabs.forEach((t, i) => {
                            if (t.content.viewContainerRef.element.nativeElement.id === 'detailListTemplateCommission') {
                                index = i;
                            }
                        });
                        if (index != null) {
                            this.commissionTitleTabGroupTemplateTabGroup.selectedIndex = index;
                        }
                    }
                }
            }),
            ...getCommissionFormSubscriptions(this.CommissionForm, this.customerDataService),
            this.statusDropdown.valueChanges.pipe(distinctUntilChanged(), withLatestFrom(this.Commission$, this.store.select(getStatusFromBackoffice), this.store.select(getEntityRole), this.userToCommissionFromCommission$, this.customizationDataService.getFeatures$())).subscribe(([v, commission, allbos, entityRoles, u2c, features]) => {
                this.ShowStatus = false;
                            if (commission.StatusBackofficeId !== +v) {
                                if (features?.includes('kaplCommissionStatus4Dialog') && allbos.find((b) => b.Id === +v).Name === StatusFromBackofficeNames.KaplStep4) {
                                    const BauleiterRole = entityRoles.find((r) => r.Slug === 'Bauleiter');
                                    const u2cBauleiter = u2c.find((u) => u.RoleId === BauleiterRole?.Id);

                                    if (!commission?.Kostenstellenart || !commission?.DepartmentId || !u2cBauleiter) {
                                        this.dialog
                                            .open<KaplStatus4DialogComponent, MissingCommissionValuesDialogData, MissingCommissionValuesResult>(
                                                KaplStatus4DialogComponent,
                                                {
                                                    data: {
                                                        CommissionIds: [commission.Id],
                                                        // add further commission ids here if several commissions need
                                                        // to be resolved together, e.g. [commission.Id, ...otherIds]
                                                        BauleiterRoleId: BauleiterRole?.Id,
                                                    },
                                                },
                                            )
                                            .afterClosed()
                                            .subscribe((result) => {
                                                if (!result) {
                                                    // user hit "Abbrechen" -> revert the dropdown so the status change
                                                    // isn't silently dropped
                                                    this.statusDropdown.setValue(commission.StatusBackofficeId, { emitEvent: false });
                                                    return;
                                                }

                                                const values = result[commission.Id];

                                                this.store.dispatch(
                                                    CommissionActionTypes.ModifyCommission({
                                                        Payload: {
                                                            id: commission.Id,
                                                            statusBackofficeId: +v,
                                                            kostenstellenart: values.Kostenstellenart,
                                                            departmentId: values.DepartmentId,
                                                        },
                                                    }),
                                                );
                                                if(!u2cBauleiter) {
                                                    this.store.dispatch(UserToCommissionActionTypes.Create({
                                                        Payload: {
                                                            userId: values.BauleiterUserId,
                                                            commissionId: commission.Id,
                                                            roleId: BauleiterRole.Id,
                                                        },
                                                    }));
                                                }
                                            });
                                        return; // don't fall through to the normal status-change dispatch below
                                    }
                                }

                    console.log('status changed', v, allbos.find(b => b.Id === +v).Name);
                    this.store.dispatch(
                        CommissionActionTypes.ModifyCommission({
                            Payload: {
                                id: commission.Id,
                                statusBackofficeId: +this.statusDropdown.value,
                            },
                        }),
                    );
                }
            }),

            this.Save$.pipe(
                withLatestFrom(this.Commission$),
                withLatestFrom(this.store.select(getDamageFlows)),
                switchMap(([[saveEvent, commission], damageFlows]) =>
                    this.store.select(
                        getPerson2EntityByCommissionId({ commissionId: commission.Id })
                    ).pipe(
                        take(1),
                        map(p2e => ([[saveEvent, commission], damageFlows, p2e] as const))
                    )
                ),
                tap(([[saveEvent, commission], damageFlows, p2e]) => {
                    const skipValidation = (saveEvent?.skipValidation || this.skipSaveChecksExceptCommssionType) ?? false;
                    const formsValid =
                        this.CommissionForm.status === 'VALID' &&
                        this.DamageFlowForm.status === 'VALID' &&
                        this.CommissionLocationForm.status === 'VALID' &&
                        this.DamageFlowLocationForm.status === 'VALID';

                    if (skipValidation || formsValid) {
                        this.Editing$.next(false);

                        saveCommission(this.store, commission, saveEvent?.wizardPage, this.CommissionForm, this.CommissionLocationForm, this.DamageFlowForm, this.DamageFlowLocationForm, damageFlows, p2e);
                        this.CommissionForm.controls.AutomaticAuftragsnummer.setValue(false);
                        this.CommissionForm.controls.AutomaticInterneNummer.setValue(false);
                    }
                }),
            ).subscribe(),
        );

        this.CommissionColor$ = combineLatest([
            this.Commission$,
            this.store.select(getCommissionTypeDictionary),
        ]).pipe(
            map(([commission, commissionTypes]) => {
                const commissionType = commissionTypes[commission.CommissionTypeId];
                return getCommissionColorValue(commission, commissionType);
            }),
        );
    }



    @HostListener('window:beforeunload')
    // tslint:disable-next-line:naming-convention
    canDeactivate(): Observable<boolean> | boolean {
        const pendingChanges = this.Editing$.value && (this.CommissionForm.dirty || this.DamageFlowLocationForm.dirty || this.DamageFlowForm.dirty || this.CommissionLocationForm.dirty);
        return !pendingChanges;
    }

    public BookingPositionClicked(s: AccountsReceivableLedgerEntity, element: HTMLElement) {
        console.log({ s, element });
        element?.classList.add('is-active');
        this.dialog
            .open(ModifyBookingOptionDialogComponent, {
                ...ModifyBookingOptionDialogComponent.DefaultConfig,
                data: { BookingOptionId: s.Id } as ModifyBookingOptionDialogComponentData,
            })
            .afterClosed()
            .subscribe(() => document.addEventListener('click', () => element?.classList.remove('is-active'), { once: true }));
    }

    public OpenPartnerSelect() {
        this.SharedCommissions$.pipe(
            withLatestFrom(this.Commission$),
            take(1),
            tap(([sc, c]) => {
                const shared = sc.filter((sc2) => sc2.CommissionId === c.Id);
                if (shared.length == 0) {
                    const s = new SharedCommissionsEntity();
                    s.CommissionId = c.Id;
                    shared.push(s);
                }
                this.dialog.open(SelectPartnerComponent, {
                    width: '500px',
                    data: shared,
                });
            }),
        ).subscribe();
    }

    public DeleteCommission() {
        firstValueFrom(combineLatest([this.Commission$, this.cls.getLabels$('Commission')])).then(([commission, commissionLabel]) => {
            this.appDialog
                .OpenConfirmationDialog({
                    paragraph: 'Soll ' + commissionLabel.Nominativ.singular.article + ' ' + commissionLabel.Nominativ.singular.value + ' wirklich gelöscht werden.',
                    styleDelete: true,
                })
                .subscribe(([result]) => {
                    result &&
                        this.store.dispatch(
                            CommissionActionTypes.DeleteCommission({
                                Payload: commission.Id,
                            }),
                        );
                    result && this.routingHistoryService.NavigateBackwards();
                });
        });
    }

    public DeleteFile(file: FileEntity) {
        this.appDialog
            .OpenConfirmationDialog({
                paragraph: `Die Datei ${file.Name} wirklich löschen?`,
            })
            .subscribe(([result]) => result && this.store.dispatch(FilesActionTypes.DeleteFileRequest({ Payload: { DocumentId: file.Id.toString() } })));
    }

    public CreateEventAndTransmission() {
        this.Commission$.pipe(take(1)).subscribe((c) => {
            const dialogRef = this.dialog.open(NewEventAndTransmissionComponent, {
                ...NewEventAndTransmissionComponent.DefaultConfig,
                data: {
                    CommissionId: c.Id,
                    CustomerId: c.CustomerId,
                    CommissionTypeId: c.CommissionTypeId,
                } as NewEventAndTransmissionComponentDialogData,
            });
            dialogRef.componentInstance.AddPersonClicked.pipe(takeUntil(dialogRef.afterClosed())).subscribe(() => this.OpenPersonDialog());
        });
    }

    public CreateCall() {
        this.Commission$.pipe(take(1)).subscribe((c) => {
            const dialogRef = this.dialog.open<NewCallComponent, NewCallComponentDialogData>(NewCallComponent, {
                ...NewCallComponent.DefaultConfig,
                data: {
                    CommissionId: c.Id,
                    CustomerId: c.CustomerId,
                },
            });
            dialogRef.componentInstance.AddPersonClicked.pipe(takeUntil(dialogRef.afterClosed())).subscribe(() => this.OpenPersonDialog());
        });
    }

    public CreateOnSiteEvent() {
        this.Commission$.pipe(take(1)).subscribe((c) => {
            const dialogRef = this.dialog.open(NewOnSiteEventComponent, {
                ...NewOnSiteEventComponent.DefaultConfig,
                data: {
                    CommissionId: c.Id,
                    CustomerId: c.CustomerId,
                } as NewOnSiteEventComponentDialogData,
            });
            dialogRef.componentInstance.AddPersonClicked.pipe(takeUntil(dialogRef.afterClosed())).subscribe(() => this.OpenPersonDialog());
        });
    }

    public CreateEvent() {
        this.Commission$.pipe(take(1)).subscribe((c) => {
            const dialogRef = this.dialog.open(NewOnSiteEventComponent, {
                ...NewOnSiteEventComponent.DefaultConfig,
                data: {
                    CommissionId: c.Id,
                    CustomerId: c.CustomerId,
                    IsNotOrtstermin: true,
                    Street: c.Street,
                    PostalCode: c.PostalCode,
                    City: c.City,
                    Country: c.Country,
                } as NewOnSiteEventComponentDialogData,
            });
            dialogRef.componentInstance.AddPersonClicked.pipe(takeUntil(dialogRef.afterClosed())).subscribe(() => this.OpenPersonDialog());
        });
    }

    public async CreateTask() {
        const user = await firstValueFrom(this.store.select(getUser));
        this.Commission$.pipe(take(1)).subscribe((c) => {
            this.dialog.open<DetailTasksComponent, DetailTasksComponentDialogData>(DetailTasksComponent, {
                ...DetailTasksComponent.DefaultConfig,
                data: {
                    InitialValues: {
                        CommissionId: c.Id,
                        CustomerId: c.CustomerId ? c.CustomerId : null,
                        UserIds: [user.Id]
                    },
                },
            });
        });
    }

    public BookmarkEvent(e, event: EventEntity) {
        if (this.IsBookmarked(event.Id)) {
            this.store.dispatch(
                BookmarkActionTypes.RemoveBookmark({
                    BookmarkIds: [this.BookmarkList.find((b) => b.EventId === event.Id).Id],
                }),
            );
        } else {
            this.store.dispatch(BookmarkActionTypes.AddBookmark({ EventId: event.Id }));
        }
        // setTimeout(() => this.cdr.detectChanges(), 1000);
        e.stopPropagation();
    }

    public IsBookmarked(eventId: number) {
        return this.BookmarkList.find((b) => b.EventId === eventId) !== undefined;
    }

    public GetContactPersonByContactPersonId(contactPersonId: number) {
        return this.PersonList.find((value) => value.Id === contactPersonId);
    }

    public OpenTimeTracker() {
        this.Commission$.pipe(first()).subscribe((commission) => {
            this.dialog.open<HourList2Component, HourListComponentDialogData>(HourList2Component, {
                ...HourList2Component.DefaultConfig,
                data: {
                    CommissionId: commission.Id,
                },
            });
        });
    }

    public OpenPersonDialog() {
        const buttonText = 'Beteiligte Personen';
        const complainTypeText = 'beteiligte person';
        this.store
            .select(getPerson2Entities)
            .pipe(
                take(1),
                withLatestFrom(this.Commission$),
                map(([pes, commission]) => pes.filter((pe) => pe.EntityType === Person2EntityEntityTypeEnum.Commission && pe.EntityId === commission.Id)),
                withLatestFrom(this.Commission$, this.store.select(getComplaintTypes).pipe(map((ct) => ct.find((c) => c.Name.toLowerCase().includes(complainTypeText))))),
            )
            .subscribe(([p2es, commission, complaintType]) => {
                let selectedIds = p2es.filter((p) => p.ComplaintTypeId === complaintType.Id).map((p2e) => p2e.PersonId);
                let selectedP2EIds = p2es.filter((p) => p.ComplaintTypeId === complaintType.Id).map((p2e) => p2e.Id);
                this.dialog
                    .open<SelectPersonsComponent, SelectPersonsComponentDialogData, PersonEntity[]>(SelectPersonsComponent, {
                        ...SelectPersonsComponent.DefaultConfig,
                        data: {
                            EntityId: commission.Id,
                            ButtonText: buttonText,
                            SelectedPersonIds: selectedIds,
                        },
                    })
                    .afterClosed()
                    .pipe(
                        filter(isNotNullOrUndefined),
                        withLatestFrom(
                            this.store.select(getPerson2Entities).pipe(
                                filter(isNotNullOrUndefined),
                                map((pes) => pes.filter((pe) => pe.EntityType === Person2EntityEntityTypeEnum.Commission && pe.EntityId === commission.Id)),
                            ),
                        ),
                        withLatestFrom(this.store.select(getComplaintTypes)),
                    )
                    .subscribe(([[selectedPersons, personEntities], complaintTypes]) => {
                        let addIds: number[] = [];
                        let delIds: number[] = [];
                        const complainTypeId = complaintTypes.find((ct) => ct.Name.toLowerCase().includes(complainTypeText.toLowerCase()))?.Id;

                        selectedPersons.forEach((p) => {
                            if (!selectedIds.includes(p.Id)) {
                                addIds.push(p.Id);
                            }
                        });
                        personEntities.forEach((pe) => {
                            if (selectedPersons.filter((p) => p.Id === pe.PersonId && pe.ComplaintTypeId === complainTypeId).length === 0) {
                                delIds.push(pe.Id);
                            }
                        });

                        addIds.forEach((pId) => {
                            this.store.dispatch(
                                Person2EntityActionTypes.AddPerson2Entity({
                                    Payload: {
                                        personId: pId,
                                        entityId: commission.Id,
                                        entityType: Person2EntityEntityTypeEnum.Commission,
                                        complaintTypeId: complainTypeId,
                                    },
                                }),
                            );
                        });

                        delIds.forEach((id) => {
                            this.store.dispatch(
                                Person2EntityActionTypes.DeletePerson2Entity({
                                    Payload: {
                                        id: id,
                                    },
                                }),
                            );
                        });
                    });
            });
    }

    GetLastNumbers(val: string) {
        const lastNumberOfString = val.match(/\d+$/);

        if (lastNumberOfString) {
            return lastNumberOfString[0];
        }
        return '0';
    }

    OpenSelectDiaryDate() {
        this.Commission$.pipe(take(1)).subscribe((commission) => {
            this.appDialog.OpenConstructionDiaryDatepickerDialog(commission.Id);
        });
    }

    // GenerateDaiary() {
    //     this.Commission$.pipe(take(1)).subscribe((commission) => {
    //         this.dialog.open<SelectDiaryTimespanDialogComponent, SelectDiaryTimespanDialogComponentDialogData, Moment | null>(SelectDiaryTimespanDialogComponent, {
    //             data: { CommissionId: commission.Id },
    //         });
    //     });
    // }

    public async OpenEditEventDialog(event: Partial<EventEntity>, element?: HTMLElement) {
        const commission = await firstValueFrom(this.Commission$);
        this.interruptionEventService.OpenEditEventDialog(event, commission.Id, element);
    }

    private setFormControls(commission: CommissionEntity, damageFlows: DamageFlowEntity[]) {
        const damageFlow = damageFlows.find((d) => d.CommissionId === commission.Id);
        this.DamageFlowLocationForm.reset({
            Street: damageFlow?.Street,
            PostalCode: damageFlow?.PostalCode,
            City: damageFlow?.City,
            Country: damageFlow?.Country,
        });
        this.CommissionLocationForm.reset({
            Street: commission.Street,
            PostalCode: commission.PostalCode,
            City: commission.City,
            Country: commission.Country,
        });
        console.log(commission);
        resetCommissionFormGroup(commission, this.CommissionForm, this.customerDataService);
        if (damageFlow) {
            this.DamageFlowForm.reset({
                AbgabeterminBerichtReal: damageFlow.AbgabeterminBerichtReal,
                DeadlineVerlaengerung: damageFlow.DeadlineVerlaengerung,
                Description: damageFlow.Description,
                DamageFlowTypeId: {
                    Name: '',
                    Id: damageFlow.DamageFlowTypeId,
                },
                ErsterBerichtEingegangen: damageFlow.ErsterBerichtEingegangen,
                ErsterOrtstermin: damageFlow.ErsterOrtstermin,
                KontaktMitVersicherungsnehmer: damageFlow.KontaktMitVersicherungsnehmer,
                ObjektiveSchadensumme: damageFlow.ObjektiveSchadensumme,
                QMDurchgefuehrtAm: damageFlow.QMDurchgefuehrtAm,
                QMStatusId: {
                    Name: '',
                    Id: damageFlow.QMStatusId,
                },
                ReportCount: damageFlow.ReportCount,
                SchadenannahmeDurchSV: damageFlow.SchadenannahmeDurchSV,
                WeiterleitungAnVu: damageFlow.WeiterleitungAnVu,
            });
        }
        this.statusDropdown.reset(commission.StatusBackofficeId, { emitEvent: false });
    }

    public OpenUploadDialog() {
        this.Commission$.pipe(take(1)).subscribe((c) => {
            this.fileDialog?.close();
            this.fileDialog = this.dialog.open<DaveFileUploadDialogComponent, DaveFileUploadDialogComponentDialogData>(DaveFileUploadDialogComponent, {
                ...DaveFileUploadDialogComponent.DefaultConfig,
                data: {
                    CommissionId: c.Id,
                    CustomerId: c.CustomerId,
                    FolderId: this.UploadFolderId,
                },
            });
        });
    }
    public OpenMapDialog(location: Address) {
        this.dialog.open(MapDialogComponent, {
            ...MapDialogComponent.DefaultConfig,
            data: location,
        });
    }
    ArraySum(arr: Array<number>) {
        return arr.reduce((prev, curr) => (curr ? prev + curr : prev), 0);
    }
    addChildCommissionClick() {
        firstValueFrom(this.Commission$).then((commission) => {
            const childids = this.store.select(getCommissionSorted).pipe(map((commissions) => commissions.filter((c) => c.ParentId === commission.Id).map((c) => c.Id)));
            const dialogRef = this.dialog.open<SelectCommissionDialogComponent, SelectCommissionDialogComponentDialogData>(SelectCommissionDialogComponent, {
                ...SelectCommissionDialogComponent.DefaultConfig,
                data: {
                    selectedCommissionIds$: childids,
                    newCommissionDefaultValues: {
                        parentId: commission.Id,
                        customerId: commission.CustomerId,
                    },
                    commissionFilter: (c: CommissionEntity) => (!c.ParentId || c.ParentId === commission.Id) && c.Id !== commission.Id && !c.Deleted,
                },
            });

            dialogRef.componentInstance.addCommissions.pipe(takeUntil(dialogRef.beforeClosed())).subscribe((addedCommissionIds) => {
                addedCommissionIds.forEach((commissionId) => {
                    this.store.dispatch(
                        CommissionActionTypes.ModifyCommission({
                            Payload: {
                                id: commissionId,
                                parentId: commission.Id,
                            },
                        }),
                    );
                });
            });

            dialogRef.componentInstance.removeCommission.pipe(takeUntil(dialogRef.beforeClosed())).subscribe((removedCommissionId) => {
                this.store.dispatch(
                    CommissionActionTypes.ModifyCommission({
                        Payload: {
                            id: removedCommissionId,
                            parentId: null,
                        },
                    }),
                );
            });
        });
    }

    protected readonly PartnerSpecificationType = PartnerSpecificationType;
    protected readonly ContactBookMeta = ContactBookMeta;
    GetRouteForPerson = ({ Id }: { Id: number }) => ['/', ContactBookMeta.Path, Id];
    protected readonly GeneratedDocumentsTypeSlugs = GeneratedDocumentsTypeSlugs;
    protected showServicePeriod = false;
    public OpenMailDialog(group?: GroupEntity, toType: 'to' | 'cc' | 'bcc' = 'to') {
        firstValueFrom(
            combineLatest([
                this.Commission$,
                this.store.select(getPersonsFetched).pipe(
                    tap((f) => {
                        if (!f) {
                            this.personResolver.resolve();
                        }
                    }),
                    filter((f) => f),
                    switchMap(() => this.store.select(getPersonDictionary)),
                ),
                this.Versicherungsnehmer$,
                this.cls.labels$,
                this.store.select(getEmployeeDictionary),
            ]),
        ).then(([commission, persons, person, labels, employees]) => {
            const targetEmail = (group ? group.GroupMembers.map((member) => (member.EmployeeId ? employees[member.EmployeeId] : persons[member.PersonId])?.Email) : commission.PersonId && [persons[commission.PersonId]?.Email])?.filter(
                (v) => v,
            );
            this.dialog.open<EmailEditorComponent, EmailEditorComponentDialogData>(EmailEditorComponent, {
                ...EmailEditorComponentDialogConfig,
                data: {
                    EmailSubject: commission.GetDisplayName(),
                    TargetEmails: (toType === 'to' && targetEmail) || [],
                    BCCEmails: (toType === 'bcc' && targetEmail) || [],
                    CCEmails: (toType === 'cc' && targetEmail) || [],
                    CustomerId: commission.CustomerId || null,
                    CommissionId: commission.Id,
                    EmailHtml: getCommissionEmailHtml(commission, labels.Commission, person),
                },
            });
        });
    }
    onAddResourcesButtonClick() {
        firstValueFrom(combineLatest([this.cls.getSingle$('RessourcePlan'), this.Commission$])).then(([planLabel, commission]) => {
            const form = new FormControl<Moment>(moment(commission.StartDate || commission.PlannedStartDate || new Date()), Validators.required);
            this.dialog
                .open<DetailListTemplateDialogComponent, DetailListTemplateDialogData, DetailListDialogReturn>(DetailListTemplateDialogComponent, {
                    ...DetailListTemplateDialogComponent.DefaultConfig,
                    data: {
                        Editing: true,
                        DisableSaveButton$: form.statusChanges.pipe(
                            startWith(form.status),
                            map((state) => state !== 'VALID'),
                        ),
                        Data: {
                            Headline: 'Automatisch ' + planLabel + ' anlegen',
                            Subline: 'Wir nutzen die hinterlegten Bedarfe, um automatisch den ' + planLabel + ' anzulegen',
                            Properties: [
                                {
                                    key: 'Startdatum',
                                    formControl: form,
                                    options: {
                                        specialInput: {
                                            date: true,
                                        },
                                    },
                                },
                            ],
                        },
                    },
                })
                .afterClosed()
                .subscribe((ret) => {
                    if (ret?.Action === 'save') {
                        this.store.dispatch(
                            EmployeeResourceScheduleActionTypes.CreateFromCommission({ Payload: { commissionId: commission.Id, commissionTypeId: commission.CommissionTypeId, startDate: FrontendDate(form.value.toDate()) } }),
                        );
                    }
                });
        });
    }

    protected readonly LedgerImportDocumentTypeNames = LedgerImportDocumentTypeNames;
    protected readonly LedgerImportDocumentTypeNumberLabel = LedgerImportDocumentTypeNumberLabel;
    protected readonly FolderTypes = FolderTypes;

    protected offerLedgerImports$ = this.Commission$.pipe(
        map(c => c.Id),
        distinctUntilChanged(),
        filter(isNotNullOrUndefined),
        switchMap(cId => this.ledgerImportDataService.getLedgerImportsFromCommissions$([cId])),
        map(lis => lis.filter(li => [LedgerImportDocumentTypes.Offer, LedgerImportDocumentTypes.OfferConfirmation, LedgerImportDocumentTypes.Measurement].includes(li.DocumentType))),
        shareReplay({refCount: true, bufferSize: 1}),
    );
    onCreateLodgerImportClick(docType: LedgerImportDocumentTypes | 'teilrechnung') {
        firstValueFrom(combineLatest([this.Commission$, this.BookingPositions$])).then(([commission, bookingPositions]) => {
            switch (docType) {
                case LedgerImportDocumentTypes.PartialInvoice:
                    this.dialog
                        .open<NewPartialInvoiceComponent, NewPartialInvoiceComponentDialogData, NewPartialInvoiceComponentDialogReturnData>(NewPartialInvoiceComponent, {
                            ...NewPartialInvoiceComponent.DefaultConfig,
                            data: {
                                FilterLedgerImports: {
                                    CommissionId: commission.Id,
                                },
                            },
                        })
                        .afterClosed()
                        .subscribe((ret) => {
                            console.log(ret);
                            if (ret?.LedgerImportCreated) {
                                this.router.navigate(['/', ReportsPageMeta.Path, AllReportsMeta.Path, ret.LedgerImportCreated]);
                            }
                        });
                    break;
                case LedgerImportDocumentTypes.ClosingInvoice:
                    this.dialog
                        .open<NewClosingInvoiceComponent, NewClosingInvoiceComponentDialogData, NewClosingInvoiceComponentDialogReturnData>(NewClosingInvoiceComponent, {
                            ...NewClosingInvoiceComponent.DefaultConfig,
                            data: {
                                FilterLedgerImports: {
                                    CommissionId: commission.Id,
                                },
                            },
                        })
                        .afterClosed()
                        .subscribe((ret) => {
                            console.log(ret);
                            if (ret?.LedgerImportCreated) {
                                this.router.navigate(['/', ReportsPageMeta.Path, AllReportsMeta.Path, ret.LedgerImportCreated]);
                            }
                        });
                    break;
                    case 'teilrechnung':
                        this.ledgerImportDataService.getLedgerImportsFromCommissions$([commission.Id]).then(ledgerImports => {
                            this.selectArlDialogService.open({
                                AllowQuantityManipulation: true,
                                AllowQuantityTypeManipulation: true,
                                AllowPriceManipulation: true,
                                AllowBezeichnungManipulation: true,
                                compareLedgerImportsForBilledArls: ledgerImports.filter(li => li.IsInvoice),
                                // SelectableLiIds: offerLedgerImports.map(li => li.Id),
                                selectableLedgerImportsFilter: {
                                    customerIds: [],
                                    commissionIds: [commission.Id],
                                    documentTypes: [LedgerImportDocumentTypes.Offer, LedgerImportDocumentTypes.OfferConfirmation, LedgerImportDocumentTypes.Measurement],
                                },
                                SelectableLiDialogTitle: `${LedgerImportDocumentTypeNames.get(LedgerImportDocumentTypes.Offer)} / ${LedgerImportDocumentTypeNames.get(LedgerImportDocumentTypes.OfferConfirmation)} / ${LedgerImportDocumentTypeNames.get(LedgerImportDocumentTypes.Measurement)} auswählen`,
                                showForceItemNumbers: false,
                                forceItemNumbersDefaultOn: false,
                            }).then(dialogRef => {
                                dialogRef.afterClosed().pipe(
                                    // withLatestFrom(dialogRef.componentInstance.dataSource.selectedLedgerImportId$, this.store.select(getLedgerImportDictionary))
                                    withLatestFrom(dialogRef.componentInstance.dataSource.selectedLedgerImportId$)
                                ).subscribe(async ([data, ledgerImportId]) => {
                                    if (data?.ArlOutput.length) {
                                        this.LS.startLoading('addLedgerImport');
                                        firstValueFrom(this.actions$.pipe(ofType(LedgerImportActionTypes.CreateLedgerImportFromLedgerImportSuccess, BaseActionTypes.ErrorAction))).then((val) => {
                                            if (val.type === LedgerImportActionTypes.CreateLedgerImportFromLedgerImportSuccess.type) {
                                                firstValueFrom(this.store.select(getLedgerImports)).then((li) => {
                                                    const newGenFileNo = li.reduce((highestId, entity) => (entity.Id > highestId ? entity.Id : highestId), -1);
                                                    this.LS.endLoading('addLedgerImport');
                                                    this.router.navigate(['/', ReportsPageMeta.Path, AllReportsMeta.Path, newGenFileNo]);
                                                });
                                            } else {
                                                this.LS.endLoading('addLedgerImport');
                                            }
                                        });

                                        const ledgerImport = await firstValueFrom(this.ledgerImportDataService.getLedgerImportId$(ledgerImportId));

                                        // let newArls: AccountsReceivableLedgerPostType[];
                                        let newArlEntities: AccountsReceivableLedgerEntity[];

                                        newArlEntities = await this.arlDataService.duplicateArlsFromState(
                                            data.ArlOutput.map((v) => ({
                                                ...v,
                                                BaseCostAllowances: data.dictionaryWithRequiredArlsForAmountCalculation[v.Id].InheritFromChildren ? data.dictionaryWithRequiredArlsForAmountCalculation[v.Id].BaseCostAllowances : [],
                                            })),
                                            data.dictionaryWithRequiredArlsForAmountCalculation,
                                            ledgerImport?.Id || null,
                                            ledgerImport?.CustomerId || null,
                                            ledgerImport?.CommissionId || null,
                                            LedgerImportDocumentTypes.Invoice || null,
                                        );


                                        this.store.dispatch(
                                            LedgerImportActionTypes.CreateLedgerImportFromLedgerImport({
                                                Payload: {
                                                    rootId: ledgerImport.Id,
                                                    isTemplate: false,
                                                    documentType: LedgerImportDocumentTypes.Invoice,
                                                    // templateName: txt,
                                                    // arlPosts: newArls,
                                                    arlIds: newArlEntities ? newArlEntities.filter(a => !a.ParentId).map(a => a.Id) : null,
                                                },
                                            }),
                                        );
                                    }
                                })

                            });
                        });
                        break;
                default:
                    this.newReportDialogService.OpenNewReportDialog({
                        DefaultValues: {
                            accountsReceivableLedgerIds: docType ? (docType !== LedgerImportDocumentTypes.Offer ? bookingPositions?.map((b) => b.Id) : []) : undefined,
                            customerId: commission.CustomerId,
                            commissionId: commission.Id,
                            documentType: docType || undefined,
                            partnerOfficeId: commission.PartnerOfficeId,
                        },
                        ARLsForCalculateAmountFromArlIds: (bookingPositions || []).reduce((acc, el) => {
                            acc[el.Id] = el;
                            return acc
                        }, {} as Dictionary<AccountsReceivableLedgerEntity>)
                    });
            }
        });
    }

    public ProcessEntryClicked(event) {
        this.router.navigate(['/', ProcessMeta.Path, event.entry.ProcessTemplateId, event.entry.Id]);
    }

    SearchButtonClicked() {
        if (!this.SearchBarActive) {
            this.SearchBarActive = true;
            setTimeout(() => this.inputRef?.nativeElement.focus(), 30);
        } else {
            if (this.SearchForm.value.length === 0) {
                this.SearchBarActive = false;
            }
        }
    }

    getMatGroupTitle(title: string, count: number) {
        if (isNotNullOrUndefined(count)) {
            return title + ' (' + count + ')';
        } else {
            return title;
        }
    }

    protected readonly ProcessMeta = ProcessMeta;
    protected readonly Person2EntityEntityTypeEnum = Person2EntityEntityTypeEnum;

    public NewReport(booked: boolean, includeMaterial?: boolean) {
        const material = includeMaterial ?? true;

        firstValueFrom(this.Commission$).then((commission) => {
            this.createArlFromCommissionService.NewReport(false, booked, commission.Id, material, commission?.CustomerId);
        });
    }

    protected departments$: Observable<DepartmentEntity[]> = this.departmentService.selectOptions$(this.Commission$.pipe(map(({DepartmentId}) => DepartmentId)))

    async NewDepartmentClick() {
        const newDepartment = await this.departmentService.addDialog();
        if (newDepartment) {
            this.CommissionForm.controls.DepartmentId.setValue(newDepartment);
        }
    }
    public CompareById = (a: SelectSearchOption<{ Id: number }>, b: SelectSearchOption<{ Id: number }>) => a.Id === b.Id;


    protected async addMissingSharepointFolder(fn: CustomFunctionsSlug) {
        console.log('## addMissingSharepointFolder', fn);
        this.LS.startLoading('DetailCommissionComponent_addMissingSharepointFolder');
        const functions = await firstValueFrom(this.customizationDataService.getFunctions$());
        const f = functions.find((f => f.Slug === fn));
        if (!f) {
            throw Error('function not found: ' + fn)
        }
        const c = await firstValueFrom(this.Commission$);
        await firstValueFrom(this.customizationDataService.callFunction$({
            slug: fn,
            Parameters: {
                'commissionId': {
                    Type: CustomisationFunctionParameterType.Id,
                    Id: c.Id.toString(),
                }
            }
        })).then((res) => {
            if (res !== null) {
                this.toastrService.success('Ordner erfolgreich erstellt')
            }
        });
        this.commissionResolver.pollUpdated();
        this.LS.endLoading('DetailCommissionComponent_addMissingSharepointFolder');
    }
}

export default DetailCommissionComponent;


